
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import Duel from './duel.js';
export default {
  data: () => ({
    stepperList: null,
    backBtn: null,
    btnInfo: null,
    sheetSaveBtn: null,
    tabs: null,
    sheetFinish: null,
    sheetCreateDuelBtn: null,
    duel: {
      userSelectPlayer: false,
      firstPlayer: {
        player: {
          id: null,
          name: null
        }
      },
      secondPlayer: {
        player: {
          id: null,
          name: null
        }
      }
    },
    days: [],
    leaguesList: [],
    leagues: [],
    doublePickMatch: false,
    players: [],
    positions: [],
    matches: [],
    dataTabs: {
      tab1: {},
      tab2: {
        leagues: [],
        days: []
      },
      tab3: {
        players: [],
        matches: [{
            selected: true,
            title: 'Все',
            value: null
          }],
        sortDetails: [
          {
            selected: true,
            title: 'Зарплата',
            value: 'salary'
          },
          {
            selected: false,
            title: 'PGP',
            value: 'pgp'
          },
          {
            selected: false,
            title: 'PTS',
            value: 'pts'
          }
        ],
        positions: [{
            selected: true,
            title: 'Все',
            value: null
          }]
      },
      tab4: {},
      tab5: {
        leagues: [],
        days: []
      },
      tab6: {
        players: [],
        matches: [{
            selected: true,
            title: 'Все',
            value: null
          }],
        sortDetails: [
          {
            selected: true,
            title: 'Зарплата',
            value: 'salary'
          },
          {
            selected: false,
            title: 'PGP',
            value: 'pgp'
          },
          {
            selected: false,
            title: 'PTS',
            value: 'pts'
          }
        ],
        positions: [{
            selected: true,
            title: 'Все',
            value: null
          }]
      },
      tab7: {}
    },
    myPlayer: {
      player: {
        id: null,
        name: null
      },
      t: ''
    },
    selectedPlayer: {
      player: {
        id: null,
        name: null
      },
      t: ''
    },
    finishState: {
      amount: 100,
      priz: 200
    }
  }),
  methods: {
    cancelCreate() {
      const self = this;
      self.$app.dialog.confirm('Вы уверены?', 'Подтверждение', function () {
        if (self.sheetCreateDuelBtn) {
          self.$app.sheet.close(self.sheetCreateDuelBtn);
        }
        self.closePage();
      });
    },
    updateTotal(e) {
      let amount = +e.target.value;
      let finishState = {
        amount: amount,
        priz: amount * 2
      };
      this.$setState({ finishState });
    },
    selectMatchTab3(e) {
      const self = this;
      self.$app.popover.get('#popover-matches-filter-tab3').close();
      const player = self.duel.getConfiguratePlayer();
      self.setTeam(e.target.value);
      self.fetchMatchPlayers(player.match.id);
    },
    selectMatchTab6(e) {
      const self = this;
      self.$app.popover.get('#popover-matches-filter-tab6').close();
      const player = self.duel.getConfiguratePlayer();
      self.setTeam(e.target.value);
      self.fetchMatchPlayers(player.match.id);
    },
    close() {
    },
    selectSortDetailTab3(e) {
      const self = this;
      this.$app.popover.get('#popover-sort-details-tab3').close();
      this.setSortDetailsPosition(e.target.value);
      const player = this.duel.getConfiguratePlayer();
      self.dataTabs.tab3.players = self.sortPlayers({
        players: [...self.dataTabs.tab3.players],
        type: e.target.value,
        tab: 3
      });
      console.log(self.dataTabs.tab3.players);
      self.$setState({ dataTabs: self.dataTabs });
    },
    selectSortDetailTab6(e) {
      const self = this;
      this.$app.popover.get('#popover-sort-details-tab6').close();
      this.setSortDetailsPosition(e.target.value);
      const player = this.duel.getConfiguratePlayer();
      self.dataTabs.tab6.players = self.sortPlayers({
        players: [...self.dataTabs.tab6.players],
        type: e.target.value,
        tab: 6
      });
      self.$setState({ dataTabs: self.dataTabs });
    },
    selectPositionTab3(e) {
      this.$app.popover.get('#popover-sort-tab3').close();
      this.setSelectedPosition(e.target.value);
      const player = this.duel.getConfiguratePlayer();
      this.fetchMatchPlayers(player.match.id);
    },
    selectPositionTab6(e) {
      this.$app.popover.get('#popover-sort-tab6').close();
      this.setSelectedPosition(e.target.value);
      const player = this.duel.getConfiguratePlayer();
      this.fetchMatchPlayers(player.match.id);
    },
    viewAlertSelectPlayer() {
      const activeTabHTML = this.getActiveTab();
      switch (activeTabHTML.getAttribute('id')) {
      case 'duel-tab-7':
        this.$app.dialog.alert('Выберите за которого игрока вы входите в дуэль', '');
        break;
      default:
        break;
      }
    },
    getActiveDay(tab) {
      const self = this;
      let result = null;
      switch (tab) {
      case 'duel-tab-1':
        result = self.dataTabs.tab2.days.find(el => el.isActive === true);
        break;
      case 'duel-tab-2':
        result = self.dataTabs.tab2.days.find(el => el.isActive === true);
        break;
      case 'duel-tab-3':
        result = self.dataTabs.tab2.days.find(el => el.isActive === true);
        break;
      case 'duel-tab-4':
        result = self.dataTabs.tab5.days.find(el => el.isActive === true);
        break;
      case 'duel-tab-5':
        result = self.dataTabs.tab5.days.find(el => el.isActive === true);
        break;
      case 'duel-tab-6':
        result = self.dataTabs.tab5.days.find(el => el.isActive === true);
        break;
      default:
        break;
      }
      return result;
    },
    infoPTS: function (e) {
      this.$root.showTooltip(e.target, 'PTS - cреднее количество очков, полученные игроком за все предыдущие игры в этом сезоне.');
    },
    infoPGP: function (e) {
      this.$root.showTooltip(e.target, 'PGP - количество очков, набранных игроком за предыдущий матч.');
    },
    setActiveDay(day) {
      const self = this;
      const days = [];
      const activeTab = this.getActiveTab();
      switch (activeTab.getAttribute('id')) {
      case 'duel-tab-2':
        self.dataTabs.tab2.days.map(element => {
          if (element.day == day) {
            element.isActive = true;
          } else {
            element.isActive = false;
          }
          days.push(element);
        });
        break;
      case 'duel-tab-5':
        self.dataTabs.tab5.days.map(element => {
          if (element.day == day) {
            element.isActive = true;
          } else {
            element.isActive = false;
          }
          days.push(element);
        });
        break;
      default:
        break;
      }
      this.$setState({ dataTabs: self.dataTabs });
    },
    getActiveTab() {
      let activeTab = null;
      this.tabs.forEach(tab => {
        if (tab.classList.contains('tab-active')) {
          activeTab = tab;
        }
      });
      return activeTab;
    },
    getSelectedPosition() {
      const activeTab = this.getActiveTab();
      let position = null;
      switch (activeTab.getAttribute('id')) {
      case 'duel-tab-2':
        position = this.dataTabs.tab3.positions.find(el => el.selected == true);
        break;
      case 'duel-tab-3':
        position = this.dataTabs.tab3.positions.find(el => el.selected == true);
        break;
      case 'duel-tab-6':
        position = this.dataTabs.tab6.positions.find(el => el.selected == true);
        break;
      case 'duel-tab-5':
        position = this.dataTabs.tab6.positions.find(el => el.selected == true);
        break;
      default:
        break;
      }
      return position;
    },
    setSelectedPosition(position) {
      let result = [];
      const activeTab = this.getActiveTab();
      switch (activeTab.getAttribute('id')) {
      case 'duel-tab-2':
        this.dataTabs.tab3.positions.map(element => {
          if (element.value == position) {
            element.selected = true;
          } else {
            element.selected = false;
          }
          result.push(element);
        });
        break;
      case 'duel-tab-3':
        this.dataTabs.tab3.positions.map(element => {
          if (element.value == position) {
            element.selected = true;
          } else {
            element.selected = false;
          }
          result.push(element);
        });
        break;
      case 'duel-tab-6':
        this.dataTabs.tab6.positions.map(element => {
          if (element.value == position) {
            element.selected = true;
          } else {
            element.selected = false;
          }
          result.push(element);
        });
        break;
      case 'duel-tab-5':
        this.dataTabs.tab6.positions.map(element => {
          if (element.value == position) {
            element.selected = true;
          } else {
            element.selected = false;
          }
          result.push(element);
        });
        break;
      default:
        break;
      }
      this.$setState({ dataTabs: this.dataTabs });
    },
    setTeam(team) {
      let result = [];
      const activeTab = this.getActiveTab();
      switch (activeTab.getAttribute('id')) {
      case 'duel-tab-2':
        this.dataTabs.tab3.matches.map(element => {
          if (element.value == team) {
            element.selected = true;
          } else {
            element.selected = false;
          }
          result.push(element);
        });
        break;
      case 'duel-tab-3':
        this.dataTabs.tab3.matches.map(element => {
          if (element.value == team) {
            element.selected = true;
          } else {
            element.selected = false;
          }
          result.push(element);
        });
        break;
      case 'duel-tab-6':
        this.dataTabs.tab6.matches.map(element => {
          if (element.value == team) {
            element.selected = true;
          } else {
            element.selected = false;
          }
          result.push(element);
        });
        break;
      case 'duel-tab-5':
        this.dataTabs.tab6.matches.map(element => {
          if (element.value == team) {
            element.selected = true;
          } else {
            element.selected = false;
          }
          result.push(element);
        });
        break;
      default:
        break;
      }
      this.$setState({ dataTabs: this.dataTabs });
    },
    setSortDetailsPosition(sortDetail) {
      let result = [];
      const activeTab = this.getActiveTab();
      switch (activeTab.getAttribute('id')) {
      case 'duel-tab-2':
        this.dataTabs.tab3.sortDetails.map(element => {
          if (element.value == sortDetail) {
            element.selected = true;
          } else {
            element.selected = false;
          }
          result.push(element);
        });
        break;
      case 'duel-tab-3':
        this.dataTabs.tab3.sortDetails.map(element => {
          if (element.value == sortDetail) {
            element.selected = true;
          } else {
            element.selected = false;
          }
          result.push(element);
        });
        break;
      case 'duel-tab-6':
        this.dataTabs.tab6.sortDetails.map(element => {
          if (element.value == sortDetail) {
            element.selected = true;
          } else {
            element.selected = false;
          }
          result.push(element);
        });
        break;
      case 'duel-tab-5':
        this.dataTabs.tab6.sortDetails.map(element => {
          if (element.value == sortDetail) {
            element.selected = true;
          } else {
            element.selected = false;
          }
          result.push(element);
        });
        break;
      default:
        break;
      }
      this.$setState({ dataTabs: this.dataTabs });
    },
    sortPlayers({players = [], type = 'salary', tab}) {
      let result = players.sort((a, b) => {
        if (type == 'salary') {
          if (+a.salary.value > +b.salary.value) {
            return -1;
          }
          if (+a.salary.value < +b.salary.value) {
            return 1;
          }
          return 0;
        }
        if (type == 'pgp') {
          if (+a.pgp > +b.pgp) {
            return -1;
          }
          if (+a.pgp < +b.pgp) {
            return 1;
          }
          return 0;
        }
        if (type == 'pts') {
          if (+a.score_average > +b.score_average) {
            return -1;
          }
          if (+a.score_average < +b.score_average) {
            return 1;
          }
          return 0;
        }
      });
      let selectedTeam = null;
      if (tab == 3) {
        selectedTeam = this.dataTabs.tab3.matches.find(el => el.selected == true);
      } else {
        selectedTeam = this.dataTabs.tab6.matches.find(el => el.selected == true);
      }
      if (selectedTeam && selectedTeam.value) {
        result = result.filter(el => {
          if (el.team == selectedTeam.value) {
            return el;
          }
        });
      }
      return result;
    },
    fetchMatchPlayers(id) {
      const self = this;
      const activeTab = this.getActiveTab();
      const tabId = activeTab.getAttribute('id');
      return new Promise(resolve => {
        self.$app.preloader.show();
        let positions = [
          'A',
          'M',
          'D',
          'G'
        ];
        if (self.getSelectedPosition() && self.getSelectedPosition().value != null) {
          positions = [self.getSelectedPosition().value];
        }
        let matches = [];
        switch (tabId) {
        case 'duel-tab-2':
          matches = this.getIdsMatches(this.dataTabs.tab2.leagues.matches);
          break;
        case 'duel-tab-5':
          matches = this.getIdsMatches(this.dataTabs.tab5.leagues.matches);
          break;
        }
        self.$root.api(`/app/personal/match/${ id }/players`, {
          positions: positions,
          matches: matches
        }, 'GET', function (data, status, xhr) {
          switch (activeTab.getAttribute('id')) {
          case 'duel-tab-2':
            self.dataTabs.tab3.players = [];
            self.dataTabs.tab3.players = self.sortPlayers({
              players: [...data.players],
              type: self.dataTabs.tab3.sortDetails.find(el => el.selected == true).value,
              tab: 3
            });
            self.dataTabs.tab3.positions = self.preparePositions(data.positions);
            self.dataTabs.tab3.matches = self.prepareTeams(data.match);
            self.dataTabs.tab3.sortDetails = self.prepareSortDetails(self.dataTabs.tab3.sortDetails);
            self.$setState({ dataTabs: self.dataTabs });
            break;
          case 'duel-tab-3':
            self.dataTabs.tab3.players = [];
            self.dataTabs.tab3.players = self.sortPlayers({
              players: [...data.players],
              type: self.dataTabs.tab3.sortDetails.find(el => el.selected == true).value,
              tab: 3
            });
            self.dataTabs.tab3.positions = self.preparePositions(data.positions);
            self.dataTabs.tab3.matches = self.prepareTeams(data.match);
            self.dataTabs.tab3.sortDetails = self.prepareSortDetails(self.dataTabs.tab3.sortDetails);
            self.$setState({ dataTabs: self.dataTabs });
            break;
          case 'duel-tab-5':
            self.dataTabs.tab6.players = [];
            self.dataTabs.tab6.players = self.sortPlayers({
              players: [...data.players],
              type: self.dataTabs.tab6.sortDetails.find(el => el.selected == true).value,
              tab: 6
            });
            self.dataTabs.tab6.positions = self.preparePositions(data.positions);
            self.dataTabs.tab6.matches = self.prepareTeams(data.match);
            self.dataTabs.tab6.sortDetails = self.prepareSortDetails(self.dataTabs.tab6.sortDetails);
            self.$setState({ dataTabs: self.dataTabs });
            break;
          case 'duel-tab-6':
            self.dataTabs.tab6.players = [];
            self.dataTabs.tab6.players = self.sortPlayers({
              players: [...data.players],
              type: self.dataTabs.tab6.sortDetails.find(el => el.selected == true).value,
              tab: 6
            });
            self.dataTabs.tab6.positions = self.preparePositions(data.positions);
            self.dataTabs.tab6.matches = self.prepareTeams(data.match);
            self.dataTabs.tab6.sortDetails = self.prepareSortDetails(self.dataTabs.tab6.sortDetails);
            self.$setState({ dataTabs: self.dataTabs });
            break;
          default:
            break;
          }
          resolve();
        }, true);
      });
    },
    getIdsMatches(matches) {
      let result = [];
      result = matches.map(el => {
        return el.id;
      });
      return result;
    },
    prepareSortDetails(sort) {
      let result = [
        {
          selected: true,
          title: 'Зарплата',
          value: 'salary'
        },
        {
          selected: false,
          title: 'PGP',
          value: 'pgp'
        },
        {
          selected: false,
          title: 'PTS',
          value: 'pts'
        }
      ];
      if (sort) {
        let s = sort.find(el => el.selected == true);
        result.map(el => {
          if (el.value == s.value) {
            el.selected = true;
          } else {
            el.selected = false;
          }
          return el;
        });
      }
      const activeTab = this.getActiveTab();
      const tabId = activeTab.getAttribute('id');
      return result;
    },
    prepareTeams(match) {
      let result = [{
          selected: true,
          title: 'Все',
          value: null
        }];
      const activeTab = this.getActiveTab();
      const tabId = activeTab.getAttribute('id');
      console.log(tabId);
      result.push({
        selected: false,
        title: match.localteam,
        value: match.localteam
      });
      result.push({
        selected: false,
        title: match.visitorteam,
        value: match.visitorteam
      });
      let matches = [];
      switch (tabId) {
      case 'duel-tab-2':
        matches = this.dataTabs.tab3.matches;
        break;
      case 'duel-tab-3':
        matches = this.dataTabs.tab3.matches;
        break;
      case 'duel-tab-5':
        matches = this.dataTabs.tab6.matches;
        break;
      case 'duel-tab-6':
        matches = this.dataTabs.tab6.matches;
        break;
      }
      if (matches.length > 0) {
        let match = null;
        matches.map(el => {
          if (el.selected == true) {
            match = el;
          }
        });
        if (match) {
          result = result.map(el => {
            console.log(el.value, match.value);
            if (el.value == match.value) {
              el.selected = true;
            } else {
              el.selected = false;
            }
            return el;
          });
        }
      }
      return result;
    },
    preparePositions(positions) {
      let result = [{
          selected: true,
          title: 'Все',
          value: null
        }];
      positions.map(position => {
        if (this.getSelectedPosition() && position.value == this.getSelectedPosition().value) {
          position.selected = true;
          result[0].selected = false;
        } else {
          position.selected = false;
        }
        result.push(position);
      });
      return result;
    },
    fetchAvailableMatches() {
      const self = this;
      return new Promise(resolve => {
        self.$app.preloader.show();
        const activeTab = self.getActiveTab();
        const date = self.getShortActiveDay(activeTab.getAttribute('id'));
        self.$root.api(`/app/personal/matches`, { date }, 'GET', function (data, status, xhr) {
          switch (activeTab.getAttribute('id')) {
          case 'duel-tab-1':
            self.dataTabs.tab2.leagues = [];
            self.$setState({ dataTabs: self.dataTabs });
            self.dataTabs.tab2.leagues = self.filterLeagues(data.dates);
            self.$setState({ dataTabs: self.dataTabs });
            break;
          case 'duel-tab-2':
            self.dataTabs.tab2.leagues = [];
            self.$setState({ dataTabs: self.dataTabs });
            self.dataTabs.tab2.leagues = self.filterLeagues(data.dates);
            self.$setState({ dataTabs: self.dataTabs });
            break;
          case 'duel-tab-4':
            self.dataTabs.tab5.leagues = [];
            self.$setState({ dataTabs: self.dataTabs });
            self.dataTabs.tab5.leagues = self.filterLeagues(data.dates);
            self.$setState({ dataTabs: self.dataTabs });
            break;
          case 'duel-tab-5':
            self.dataTabs.tab5.leagues = [];
            self.$setState({ dataTabs: self.dataTabs });
            self.dataTabs.tab5.leagues = self.filterLeagues(data.dates);
            self.$setState({ dataTabs: self.dataTabs });
            break;
          default:
            break;
          }
          resolve();
        }, true);
      });
    },
    getShortActiveDay(tab) {
      const activeDay = this.getActiveDay(tab);
      let day = activeDay.date.getDate();
      if (day < 10) {
        day = `0${ day }`;
      }
      let month = activeDay.date.getMonth() + 1;
      if (month < 10) {
        month = `0${ month }`;
      }
      let year = activeDay.date.getFullYear();
      return `${ day }.${ month }.${ year }`;
    },
    filterLeagues(data) {
      const leagues = [];
      data.map(element => {
        element.leagues.map(league => {
          let matches = [];
          league.matches.map(match => {
            let date = new Date(match.started_at);
            let day = date.getDate();
            if (day < 10) {
              day = '0' + day;
            }
            let month = date.getMonth() + 1;
            if (month < 10) {
              month = '0' + month;
            }
            let year = date.getFullYear();
            year = String(year).slice(-2);
            let hours = date.getHours();
            if (hours < 10) {
              hours = '0' + hours;
            }
            let minutes = date.getMinutes();
            if (minutes < 10) {
              minutes = '0' + minutes;
            }
            match.shortDate = `${ day }.${ month }.${ year } ${ hours }:${ minutes }`;
            matches.push(match);
          });
          leagues.matches = matches;
          leagues.push(league);
        });
      });
      return leagues;
    },
    plus() {
      this.finishState.amount += 100;
      this.finishState.priz = this.finishState.amount * 2;
      this.$setState({ finishState: this.finishState });
    },
    minus() {
      if (this.finishState.amount > 100) {
        this.finishState.amount -= 100;
        this.finishState.priz = this.finishState.amount * 2;
        this.$setState({ finishState: this.finishState });
      }
    },
    saveDuel() {
      const self = this;
      let payload = {
        match_1_id: this.duel.firstPlayer.match.id,
        player_1_id: this.duel.firstPlayer.player.id,
        match_2_id: this.duel.secondPlayer.match.id,
        player_2_id: this.duel.secondPlayer.player.id,
        amount: this.finishState.amount,
        selected_player_id: this.myPlayer.player.id
      };
      let duel = this.duel;
      let myPlayer = this.selectedPlayer;
      let myInfo = this.$root.params.profile;
      myInfo.priz = this.finishState;
      myPlayer.me = myInfo;
      duel.userSelectPlayer = true;
      duel.myPlayer = this.selectedPlayer;
      self.$setState({
        duel: duel,
        myPlayer: this.selectedPlayer
      });
      console.log(this.duel);
      self.sheetFinish.close();
    },
    createDuel() {
      const self = this;
      let payload = {
        match_1_id: this.duel.firstPlayer.match.id,
        player_1_id: this.duel.firstPlayer.player.id,
        match_2_id: this.duel.secondPlayer.match.id,
        player_2_id: this.duel.secondPlayer.player.id,
        amount: this.finishState.amount,
        selected_player_id: this.myPlayer.player.id
      };
      self.$app.preloader.show();
      self.$root.api(`/app/personal/duel/create`, { ...payload }, 'POST', function (data, status, xhr) {
        try {
          if (data.status == 'ok') {
            self.$root.events.emit('lobby.loadDuels');
            self.sheetFinish.close();
            self.$app.sheet.close(self.sheetCreateDuelBtn);
            self.closePage();
          } else {
            self.$app.preloader.hide();
            self.$app.dialog.alert(data.message, data.title);
          }
        } catch (e) {
          self.$app.preloader.hide();
          self.closePage();
        }
      }, true);
    },
    selectMyPlayer(id) {
      var player = null;
      if (id == 'first') {
        player = this.duel.firstPlayer;
      } else if (id == 'second') {
        player = this.duel.secondPlayer;
      } else {
        player = this.duel.getPlayerById(id);
      }
      if (!player) {
        alert('Неизвестная ошибка');
        return false;
      }
      this.sheetFinish = this.$app.sheet.create({
        el: this.sheetDuelFinish,
        backdrop: true
      });
      let name = player.player.firstname + ' ' + player.player.lastname;
      let fullLength = 23;
      const w = window.innerWidth;
      if (w <= 426 && w >= 376) {
      } else if (w < 376 && w >= 321) {
        fullLength = 21;
      } else {
        fullLength = 17;
      }
      if (name.length >= fullLength) {
        name = name.slice(0, fullLength).concat('..');
      }
      player.player.h_name = name;
      this.$setState({
        selectedPlayer: player,
        finishState: {
          amount: 100,
          priz: 200
        }
      });
      if (this.myPlayer.player.id == this.selectedPlayer.player.id && this.myPlayer.me) {
        this.$setState({
          finishState: {
            amount: this.myPlayer.me.priz.amount,
            priz: this.myPlayer.me.priz.priz
          }
        });
      }
      console.log('this.myPlayer', this.myPlayer);
      console.log('player', player);
      console.log('selectedPlayer', this.selectedPlayer);
      this.sheetFinish.open();
    },
    preventEvent(e) {
      e.preventDefault();
    },
    toLobby() {
      this.$router.back();
    },
    next() {
      const self = this;
      let activeTab = null;
      this.tabs.forEach(el => {
        if (el.classList.contains('tab-active')) {
          activeTab = el;
        }
      });
      const id = activeTab.getAttribute('id');
      const player = this.duel.getConfiguratePlayer();
      switch (id) {
      case 'duel-tab-2':
        if (!player.match.id) {
          this.$app.dialog.alert('Выберите матч', '');
          return false;
        }
        this.fetchMatchPlayers(player.match.id).then(() => {
          self.showStep3();
        });
        break;
      case 'duel-tab-5':
        if (!player.match.id) {
          this.$app.dialog.alert('Выберите матч', '');
          return false;
        }
        this.fetchMatchPlayers(player.match.id).then(() => {
          self.showStep6();
        });
        break;
      default:
        break;
      }
    },
    showStep1() {
      this.$app.tab.show('#duel-tab-1', true);
      this.btnInfo.style.opacity = 0;
      this.$app.sheet.close(this.sheetSaveBtn);
      this.checkActiveTab();
    },
    pickDuelPlayer(nPlayer) {
      const self = this;
      if (this.duel.firstPlayer.player.id === null && this.duel.secondPlayer.player.id === null) {
        if (nPlayer == 1) {
          if (this.duel.firstPlayer.player.id != null) {
            return false;
          }
          this.duel.firstPlayer.order = 1;
          this.duel.firstPlayer.configurate = true;
          this.duel.secondPlayer.order = 2;
          this.duel.secondPlayer.configurate = false;
        } else {
          if (this.duel.secondPlayer.player.id != null) {
            return false;
          }
          this.duel.firstPlayer.order = 2;
          this.duel.firstPlayer.configurate = false;
          this.duel.secondPlayer.order = 1;
          this.duel.secondPlayer.configurate = true;
        }
      } else {
        this.duel.changeConfiguratePlayer();
      }
      if (this.duel.firstPlayer.player.id != null || this.duel.secondPlayer.player.id != null) {
        this.showStep5();
      } else {
        this.showStep2();
      }
    },
    showStep2() {
      const self = this;
      console.log(2);
      this.btnInfo.style.opacity = 1;
      this.HANDLE_STEP_2().then(() => {
        self.$app.tab.show('#duel-tab-2', true);
        self.backBtn.style.opacity = 1;
        self.checkActiveTab();
        self.sheetSaveBtn = self.$el.find('.sheet-save-btn')[0];
        self.$app.sheet.open(self.sheetSaveBtn);
      });
    },
    showStep3() {
      console.log(this.dataTabs);
      this.$app.tab.show('#duel-tab-3', true);
      this.checkActiveTab();
      this.setActiveStep(1);
    },
    showStep4() {
      this.$app.sheet.open(this.sheetCreateDuelBtn);
      this.$app.tab.show('#duel-tab-4', true);
      this.checkActiveTab();
    },
    showStep5() {
      this.HANDLE_STEP_5().then(() => {
        this.$app.tab.show('#duel-tab-5', true);
        this.checkActiveTab();
        this.$app.sheet.open(this.sheetSaveBtn);
      });
    },
    showStep6() {
      this.$app.tab.show('#duel-tab-6', true);
      this.checkActiveTab();
      this.setActiveStep(3);
    },
    showStep7() {
      this.$app.tab.show('#duel-tab-7', true);
      this.checkActiveTab();
    },
    pickPlayer(id, tab) {
      const self = this;
      const player = this.duel.getConfiguratePlayer();
      const activeTab = this.getActiveTab();
      let playerInList = null;
      switch (activeTab.getAttribute('id')) {
      case 'duel-tab-3':
        playerInList = self.dataTabs.tab3.players.find(player => player.id == id);
        break;
      case 'duel-tab-6':
        playerInList = self.dataTabs.tab6.players.find(player => player.id == id);
      default:
        break;
      }
      if (player.order == 1) {
        if (this.duel.secondPlayer) {
          if (this.duel.secondPlayer.player.id == playerInList.id) {
            self.$app.dialog.alert('Нельзя выбирать одинаковых игроков');
            return false;
          }
        }
      } else {
        if (this.duel.firstPlayer) {
          if (this.duel.firstPlayer.player.id == playerInList.id) {
            self.$app.dialog.alert('Нельзя выбирать одинаковых игроков');
            return false;
          }
        }
      }
      if (player.match.localteam == playerInList.team) {
        player.match.myTeam = 'localteam';
      } else {
        player.match.myTeam = 'visitorteam';
      }
      player.player = playerInList;
      if (this.duel.firstPlayer.match.id !== null) {
        this.duel.firstPlayer.match.localteam = this.duel.firstPlayer.match.localteam.slice(0, 3).replace(/\s/g, '').toUpperCase();
        ;
        this.duel.firstPlayer.match.visitorteam = this.duel.firstPlayer.match.visitorteam.slice(0, 3).replace(/\s/g, '').toUpperCase();
        ;
      }
      if (this.duel.secondPlayer.match.id !== null) {
        this.duel.secondPlayer.match.localteam = this.duel.secondPlayer.match.localteam.slice(0, 3).replace(/\s/g, '').toUpperCase();
        ;
        this.duel.secondPlayer.match.visitorteam = this.duel.secondPlayer.match.visitorteam.slice(0, 3).replace(/\s/g, '').toUpperCase();
        ;
      }
      let fullLength = 14;
      const w = window.innerWidth;
      if (w <= 426 && w >= 376) {
      } else if (w < 376 && w >= 321) {
        fullLength = 11;
      } else {
        fullLength = 7;
      }
      this.duel.firstPlayer.player.h_firstname = this.duel.firstPlayer.player.firstname;
      this.duel.firstPlayer.player.h_lastname = this.duel.firstPlayer.player.lastname;
      this.duel.secondPlayer.player.h_firstname = this.duel.secondPlayer.player.firstname;
      this.duel.secondPlayer.player.h_lastname = this.duel.secondPlayer.player.lastname;
      if (this.duel.firstPlayer.player.id && this.duel.firstPlayer.player.firstname.length > fullLength) {
        this.duel.firstPlayer.player.h_firstname = this.duel.firstPlayer.player.firstname.slice(0, fullLength).concat('..');
      }
      if (this.duel.firstPlayer.player.id && this.duel.firstPlayer.player.lastname.length > fullLength) {
        this.duel.firstPlayer.player.h_lastname = this.duel.firstPlayer.player.lastname.slice(0, fullLength).concat('..');
      }
      if (this.duel.secondPlayer.player.id && this.duel.secondPlayer.player.firstname.length > fullLength) {
        this.duel.secondPlayer.player.h_firstname = this.duel.secondPlayer.player.firstname.slice(0, fullLength).concat('..');
      }
      if (this.duel.secondPlayer.player.id && this.duel.secondPlayer.player.lastname.length > fullLength) {
        this.duel.secondPlayer.player.h_lastname = this.duel.secondPlayer.player.lastname.slice(0, fullLength).concat('..');
      }
      console.log(this.duel.firstPlayer.player);
      this.$setState({ duel: this.duel });
      if (tab == 4) {
        this.showStep4();
      } else {
        this.showStep7();
      }
    },
    getMatchById(id) {
      const self = this;
      const activeTab = this.getActiveTab();
      let result = null;
      switch (activeTab.getAttribute('id')) {
      case 'duel-tab-2':
        this.dataTabs.tab2.leagues.map(el => {
          el.matches.map(match => {
            if (match.id == id) {
              result = { ...match };
            }
          });
        });
        break;
      case 'duel-tab-5':
        this.dataTabs.tab5.leagues.map(el => {
          el.matches.map(match => {
            if (match.id == id) {
              result = { ...match };
            }
          });
        });
        break;
      default:
        break;
      }
      return result;
    },
    pickMatch(id) {
      const self = this;
      const activeTab = this.getActiveTab();
      let matchElement = this.$el.find(`#${ this.getActiveTab().getAttribute('id') }`)[0].querySelector(`#match-${ id }`);
      const player = this.duel.getConfiguratePlayer();
      player.match = this.getMatchById(id);
      const matchesElement = this.$el.find(`#${ this.getActiveTab().getAttribute('id') }`)[0].querySelector('.matches').querySelectorAll('.match');
      const inputElement = matchElement.querySelector('input[type="radio"]');
      if (!this.doublePickMatch) {
        this.doublePickMatch = true;
        matchesElement.forEach(el => {
          el.querySelector('input[type="radio"]').removeAttribute('checked');
        });
        inputElement.setAttribute('checked', true);
        setTimeout(() => {
          self.$setState({ doublePickMatch: false });
        }, 0);
      }
    },
    resetDataTabs() {
      this.$setState({
        dataTabs: {
          tab1: {},
          tab2: {
            leagues: [],
            days: []
          },
          tab3: {
            players: [],
            matches: [{
                selected: true,
                title: 'Все',
                value: null
              }],
            sortDetails: [
              {
                selected: true,
                title: 'Зарплата',
                value: 'salary'
              },
              {
                selected: false,
                title: 'PGP',
                value: 'pgp'
              },
              {
                selected: false,
                title: 'PTS',
                value: 'pts'
              }
            ],
            positions: [{
                selected: true,
                title: 'Все',
                value: null
              }]
          },
          tab4: {},
          tab5: {
            leagues: [],
            days: []
          },
          tab6: {
            players: [],
            matches: [{
                selected: true,
                title: 'Все',
                value: null
              }],
            sortDetails: [
              {
                selected: true,
                title: 'Зарплата',
                value: 'salary'
              },
              {
                selected: false,
                title: 'PGP',
                value: 'pgp'
              },
              {
                selected: false,
                title: 'PTS',
                value: 'pts'
              }
            ],
            positions: [{
                selected: true,
                title: 'Все',
                value: null
              }]
          },
          tab7: {}
        }
      });
    },
    HANDLE_STEP_1() {
      const self = this;
      this.backBtn.addEventListener('click', e => {
        e.preventDefault();
        const activeTabHTML = self.getActiveTab();
        switch (activeTabHTML.getAttribute('id')) {
        case 'duel-tab-1':
          this.closePage();
          break;
        default:
          break;
        }
      });
      const matchElements = this.$el.find('#duel-tab-2')[0].querySelector('.matches').querySelectorAll('.match');
      matchElements.forEach(el => {
        el.querySelector('input[type="radio"]').removeAttribute('checked');
      });
      setTimeout(() => {
        this.resetDataTabs();
        this.duel.destroy();
      }, 250);
    },
    HANDLE_STEP_2() {
      const self = this;
      const player = this.duel.getConfiguratePlayer();
      const activeTab = this.getActiveTab();
      self.dataTabs.tab3.positions = [];
      self.dataTabs.tab3.matches = [];
      this.$setState({ dataTabs: self.dataTabs });
      const tab3HTML = this.$el.find('#duel-tab-3')[0];
      let sortTitle = tab3HTML.querySelector('#sort-title');
      sortTitle.textContent = 'Роль';
      return new Promise(resolve => {
        this.setActiveStep(0);
        if (this.dataTabs.tab2.leagues.length === 0) {
          calendareInit();
          this.fetchAvailableMatches().then(() => {
            resolve();
          });
        } else {
          if (activeTab.getAttribute('id') == 'duel-tab-3') {
            const matchElements = this.$el.find('#duel-tab-2')[0].querySelector('.matches').querySelectorAll('.match');
            matchElements.forEach(el => {
              if (el.getAttribute('id') == `match-${ player.match.id }`) {
                el.querySelector('input[type="radio"]').setAttribute('checked', true);
              }
            });
          }
          resolve();
        }
        function calendareInit() {
          let days = [];
          let dimmyWeek = [
            {
              number: 1,
              text: 'ПН'
            },
            {
              number: 2,
              text: 'ВТ'
            },
            {
              number: 3,
              text: 'СР'
            },
            {
              number: 4,
              text: 'ЧТ'
            },
            {
              number: 5,
              text: 'ПТ'
            },
            {
              number: 6,
              text: 'СБ'
            },
            {
              number: 0,
              text: 'ВС'
            }
          ];
          let count = 0;
          while (days.length != 7) {
            const today = new Date();
            const currentDate = new Date(today);
            currentDate.setDate(currentDate.getDate() + count);
            let day = {
              isActive: false,
              date: currentDate,
              day: currentDate.getDate(),
              text: dimmyWeek.find(el => el.number == currentDate.getDay()).text,
              toDay: false,
              count: count + 1
            };
            if (count == 0) {
              day.toDay = true;
              day.isActive = true;
            }
            days.push(day);
            count += 1;
          }
          self.dataTabs.tab2.days = days;
          self.$setState({ dataTabs: self.dataTabs });
        }
      });
    },
    handleStep3() {
      const self = this;
      self.setActiveStep(1);
    },
    handleStep4() {
      this.duel.setConfiguratePlayerWithOrder();
      const secondOrderPlayer = this.duel.getOrderPlayer(2);
      secondOrderPlayer.match = { id: null };
      secondOrderPlayer.player = { id: null };
      this.$setState({ duel: this.duel });
      const matchElements = this.$el.find('#duel-tab-5')[0].querySelector('.matches').querySelectorAll('.match');
      matchElements.forEach(el => {
        el.querySelector('input[type="radio"]').removeAttribute('checked');
      });
      setTimeout(() => {
        this.dataTabs.tab5.leagues = [];
        this.$setState({ dataTabs: this.dataTabs });
      }, 250);
      this.setActiveStep(2);
    },
    HANDLE_STEP_5() {
      const self = this;
      const player = this.duel.getConfiguratePlayer();
      const activeTab = this.getActiveTab();
      this.$app.sheet.close(this.sheetCreateDuelBtn);
      self.dataTabs.tab6.positions = [];
      self.dataTabs.tab6.matches = [];
      this.$setState({ dataTabs: self.dataTabs });
      const tab6HTML = this.$el.find('#duel-tab-6')[0];
      let sortTitle = tab6HTML.querySelector('#sort-title');
      sortTitle.textContent = 'Роль';
      return new Promise(resolve => {
        if (self.dataTabs.tab5.leagues.length === 0) {
          calendareInit();
          this.fetchAvailableMatches().then(() => {
            resolve();
          });
        } else {
          if (activeTab.getAttribute('id') == 'duel-tab-6') {
            const matchElements = this.$el.find('#duel-tab-5')[0].querySelector('.matches').querySelectorAll('.match');
            matchElements.forEach(el => {
              if (el.getAttribute('id') == `match-${ player.match.id }`) {
                el.querySelector('input[type="radio"]').setAttribute('checked', true);
              }
            });
          }
          resolve();
        }
        function calendareInit() {
          let days = [];
          let dimmyWeek = [
            {
              number: 1,
              text: 'ПН'
            },
            {
              number: 2,
              text: 'ВТ'
            },
            {
              number: 3,
              text: 'СР'
            },
            {
              number: 4,
              text: 'ЧТ'
            },
            {
              number: 5,
              text: 'ПТ'
            },
            {
              number: 6,
              text: 'СБ'
            },
            {
              number: 0,
              text: 'ВС'
            }
          ];
          let count = 0;
          while (days.length != 7) {
            const today = new Date();
            const currentDate = new Date(today);
            currentDate.setDate(currentDate.getDate() + count);
            let day = {
              isActive: false,
              date: currentDate,
              day: currentDate.getDate(),
              text: dimmyWeek.find(el => el.number == currentDate.getDay()).text,
              toDay: false,
              count: count + 1
            };
            if (count == 0) {
              day.toDay = true;
              day.isActive = true;
            }
            days.push(day);
            count += 1;
          }
          self.dataTabs.tab5.days = days;
          self.$setState({ dataTabs: self.dataTabs });
        }
      });
    },
    handleStep6() {
      this.setActiveStep(3);
    },
    handleStep7() {
      this.$app.sheet.open(this.sheetCreateDuelBtn);
      this.setActiveStep(4);
    },
    removeAllCheckedMatches() {
      const matchElements2 = this.$el.find('#duel-tab-2')[0].querySelector('.matches').querySelectorAll('.match');
      matchElements2.forEach(el => {
        el.querySelector('input[type="radio"]').removeAttribute('checked');
      });
      const matchElements5 = this.$el.find('#duel-tab-5')[0].querySelector('.matches').querySelectorAll('.match');
      matchElements5.forEach(el => {
        el.querySelector('input[type="radio"]').removeAttribute('checked');
      });
    },
    pickDay(day) {
      const self = this;
      const activeTab = this.getActiveTab();
      const player = this.duel.getConfiguratePlayer();
      const daysElements = this.$el.find(`#${ activeTab.getAttribute('id') }`)[0].querySelector('.calendar').querySelectorAll('.day');
      let isDay = null;
      switch (activeTab.getAttribute('id')) {
      case 'duel-tab-2':
        isDay = this.dataTabs.tab2.days.find(el => el.day == day);
        break;
      case 'duel-tab-5':
        isDay = this.dataTabs.tab5.days.find(el => el.day == day);
        break;
      default:
        break;
      }
      daysElements.forEach(el => {
        if (el.classList.contains('active')) {
          el.classList.remove('active');
        }
      });
      daysElements[isDay.count - 1].classList.add('active');
      this.setActiveDay(day);
      this.fetchAvailableMatches().then(() => {
        const matchElements = self.$el.find(`#${ activeTab.getAttribute('id') }`)[0].querySelector('.matches').querySelectorAll('.match');
        matchElements.forEach(el => {
          el.querySelector('input[type="radio"]').removeAttribute('checked');
        });
        player.match = { id: null };
      });
    },
    checkActiveTab() {
      const self = this;
      this.tabs.forEach(el => {
        switch (el.getAttribute('id')) {
        case 'duel-tab-1':
          let duel = this.duel;
          duel.userSelectPlayer = false;
          this.$setState({ duel });
          this.backBtn.removeEventListener('click', this.showStep1);
          if (el.classList.contains('tab-active')) {
            this.HANDLE_STEP_1();
          }
          break;
        case 'duel-tab-2':
          this.backBtn.removeEventListener('click', this.showStep2);
          if (el.classList.contains('tab-active')) {
            this.backBtn.style.opacity = 1;
            this.$app.sheet.close(this.sheetCreateDuelBtn);
            this.backBtn.addEventListener('click', this.showStep1);
          }
          break;
        case 'duel-tab-3':
          this.$app.sheet.close(this.sheetSaveBtn);
          this.backBtn.removeEventListener('click', this.showStep3);
          if (el.classList.contains('tab-active')) {
            this.$app.sheet.close(this.sheetCreateDuelBtn);
            this.backBtn.addEventListener('click', this.showStep2);
          }
          break;
        case 'duel-tab-4':
          this.backBtn.removeEventListener('click', this.showStep4);
          this.$app.sheet.close(this.sheetSaveBtn);
          if (el.classList.contains('tab-active')) {
            this.handleStep4();
            this.backBtn.addEventListener('click', this.showStep3);
          }
          break;
        case 'duel-tab-5':
          this.backBtn.removeEventListener('click', this.showStep5);
          if (el.classList.contains('tab-active')) {
            this.backBtn.addEventListener('click', this.showStep4);
          }
          break;
        case 'duel-tab-6':
          this.backBtn.removeEventListener('click', this.showStep6);
          if (el.classList.contains('tab-active')) {
            this.$app.sheet.close(this.sheetCreateDuelBtn);
            setTimeout(() => {
              let duel = this.duel;
              duel.userSelectPlayer = false;
              this.$setState({ duel });
            }, 250);
            this.backBtn.addEventListener('click', this.showStep5);
          }
          break;
        case 'duel-tab-7':
          this.backBtn.removeEventListener('click', this.showStep7);
          if (el.classList.contains('tab-active')) {
            this.handleStep7();
            this.backBtn.addEventListener('click', this.showStep6);
          }
          break;
        default:
          break;
        }
      });
    },
    setActiveStep(number) {
      this.stepperList.querySelectorAll('li').forEach(element => {
        if (element.classList.contains('active')) {
          element.classList.remove('active');
        }
      });
      this.stepperList.querySelectorAll('li')[number].classList.add('active');
    },
    closePage() {
      if (this.sheetSaveBtn) {
        this.$app.sheet.close(this.sheetSaveBtn);
      }
      this.$router.back();
      document.querySelector('.toolbar').style.display = 'block';
      this.duel.destroy();
      setTimeout(() => {
      }, 0);
    }
  },
  on: {
    pageBeforeIn: function () {
      let root = document.documentElement;
      root.style.setProperty('--view-lobby-padding-top', '44px');
    },
    pageAfterOut: function () {
      let root = document.documentElement;
      root.style.setProperty('--view-lobby-padding-top', '98px');
    },
    pageInit: function () {
      this.stepperList = this.$app.navbar.getElByPage(this.$el).querySelector('.stepper-list');
      this.backBtn = this.$app.navbar.getElByPage(this.$el).querySelector('.left .link');
      this.btnInfo = this.$app.navbar.getElByPage(this.$el).querySelector('.right .link');
      this.btnInfo.style.opacity = 0;
      this.tabs = this.$el.find('.duel-tabs')[0].querySelector('.tabs').querySelectorAll('.page-content');
      this.sheetDuelFinish = this.$el.find('.sheet-finish-duel')[0];
      this.sheetCreateDuelBtn = this.$el.find('.sheet-сreate-duel-btn')[0];
      let duel = this.duel;
      duel.userSelectPlayer = false;
      this.$setState({ duel });
      this.checkActiveTab();
      const playersListElements = this.$el.find('.list.players');
      const matchesListElements = this.$el.find('.tab > .matches');
      const sb = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--f7-safe-area-bottom'));
      playersListElements.forEach(el => {
        el.style.height = window.innerHeight - 106 - sb * 1 + 'px';
      });
      matchesListElements.forEach(el => {
        el.style.height = window.innerHeight - 88 - 80 - sb * 2.5 + 'px';
      });
      this.duel = Duel.init();
    }
  },
  id: '39df4b0ac3',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page duel-creation-page" data-name="duel-creation">\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner">\n        <div class="left">\n          <a href="#" class="link icon-only icon-only">\n              <i class="icon icon-back"></i>\n          </a>\n        </div>\n        <div class="title">\n          <ul class="stepper-list">\n            <li class="active"><span>1</span></li>\n            <li><span>2</span></li>\n            <li><span>3</span></li>\n            <li><span>4</span></li>\n            <li><span><i class="icon icon-flag-svg"></i></span></li>\n            <div class="line"></div>\n          </ul>\n        </div>\n        <div class="right" @click="cancelCreate">\n          <a href="#" class="link" style="margin-right: 8px;">Закрыть</a>\n        </div>\n      </div>\n    </div>\n    <div class="page-content">\n      <div class="tabs-animated-wrap duel-tabs">\n        <div class="tabs">\n          <!-- ТАБ 1 -->\n          <div id="duel-tab-1" class="page-content tab tab-active pt-0">\n            <div class="block">\n              <div class="header">\n                <span class="title">Создание дуэли</span>\n                <span class="subtitle">На матчи ближайшей недели</span>\n              </div>\n            </div>\n            <div class="players-box">\n              <div class="box-row">\n                <div class="player-box first-player">\n                  <div class="body" @click="pickDuelPlayer(1)">\n                    <div class="player">\n                      <i class="f7-icons">plus</i>\n                    </div>\n                    <div class="description">\n                      <span class="add-player-text">Добавить<br>игрока</span>\n                    </div>\n                  </div>\n                </div>\n                <div class="player-box second-player">\n                  <div class="body" @click="pickDuelPlayer(2)">\n                    <div class="description">\n                      <span class="add-player-text">Добавить<br>игрока</span>\n                    </div>\n                    <div class="player">\n                      <i class="f7-icons">plus</i>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div class="box-row">\n                <div class="player-box footer">\n                  <span class="disabled">Выбрать</span>\n                </div>\n                <div class="player-box footer">\n                  <span class="disabled">Выбрать</span>\n                </div>\n              </div>\n            </div>\n          </div>\n          <!-- ТАБ 2 -->\n          <div id="duel-tab-2" class="page-content tab pt-0">\n            ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.dataTabs, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n              ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.tab2, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <div class="calendar">\n                  ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.days, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                    <div class="day ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.toDay == true', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += 'today';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += ' ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.isActive == true', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += 'active';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '" @click="pickDay(\'';
                  r += c(ctx_4.day, ctx_4);
                  r += '\')">\n                      <div class="content">\n                        <span>';
                  r += c(ctx_4.text, ctx_4);
                  r += '</span>\n                        <span>';
                  r += c(ctx_4.day, ctx_4);
                  r += '</span>\n                      </div>\n                    </div>\n                  ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                </div>\n                <div class="matches">\n                  <div class="title">Выберите матч</div>\n                  <div class="list list-matches accordion-list accordion-opposite">\n                    <ul class="leagues">\n                      ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.leagues, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <li class="accordion-item"><a class="item-content item-link" href="#">\n                            <div class="item-inner">\n                              <div class="item-title">';
                  r += c(ctx_4.name, ctx_4);
                  r += '</div>\n                            </div>\n                          </a>\n                          <div class="accordion-item-content">\n                            <ul class="matches">\n                              ';
                  r += Template7Helpers.each.call(ctx_4, ctx_4.matches, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                <li id="match-';
                      r += c(ctx_5.id, ctx_5);
                      r += '" class="match" @click="pickMatch(\'';
                      r += c(ctx_5.id, ctx_5);
                      r += '\')">\n                                  <div class="match-row">\n                                    <label class="radio item-radio" @click="preventEvent">\n                                      <input type="radio" name="match-tab2" value="';
                      r += c(ctx_5.id, ctx_5);
                      r += '">\n                                      <i class="icon-radio"></i>\n                                    </label>\n                                    <div class="match-block">\n                                      <span class="match-title">';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.is_virtual, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '<span>*</span>';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += c(ctx_5.localteam, ctx_5);
                      r += ' - ';
                      r += c(ctx_5.visitorteam, ctx_5);
                      r += '</span>\n                                      <span class="match-data">';
                      r += c(ctx_5.shortDate, ctx_5);
                      r += '</span>\n                                    </div>\n                                  </div>\n                                </li>\n                              ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                            </ul>\n                          </div>\n                        </li>\n                      ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                    </ul>\n                  </div>\n                </div>\n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          </div>\n          <!-- ТАБ 3 -->\n          <div id="duel-tab-3" class="page-content tab pt-0">\n            ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.dataTabs, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n              ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.tab3, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <div class="filter-row">\n                  <a href="#" class="link popover-open" data-popover="#popover-matches-filter-tab3">\n                    <span id="filter-title">Команда</span>\n                    <i class="f7-icons icon">chevron_down</i>\n                  </a>\n                  <a href="#" class="link popover-open" data-popover="#popover-sort-tab3">\n                    <span id="sort-title">Роль</span>\n                    <i class="f7-icons icon">chevron_down</i>\n                  </a>\n                  <a href="#" class="link popover-open" data-popover="#popover-sort-details-tab3">\n                    <span id="sort-detaile-title">Сорт.</span>\n                    <i class="f7-icons icon">chevron_down</i>\n                  </a>\n                </div>\n                <div class="list players no-chevron">\n                  <ul>\n                    ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.players, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                      <li class="bg-color-white">\n                        <div class="item-content list-full-content">\n                            <div class="item-media">\n                                <a class="item-media__face" href="#">\n                                    <img src="';
                  r += c(ctx_4.image, ctx_4);
                  r += '" class="game-avatar">\n                                    ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.in_lineups, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                        <span class="item-media__in_lineups tour-7"></span>\n                                    ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.is_injured, {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      return r;
                    },
                    inverse: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                        ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.is_injured, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                            <span class="item-media__is_injured tour-7"></span>\n                                        ';
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                            <span class="tour-7"></span>\n                                        ';
                          return r;
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                                    ';
                      return r;
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                </a>\n                            </div>\n                            <div class="item-inner">\n                              <div class="width-100 min-width-0">\n                                <div class="list-full-top display-flex justify-content-space-between align-content-center">\n                                  <div class="list-full-top-left">\n                                    ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.is_having_stats, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                      <i class="icon icon-player-has-stat" style="margin-top: -3px;"></i>\n                                    ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                      <a href="/player/info?player_id=';
                  r += c(ctx_4.id, ctx_4);
                  r += '">';
                  r += Template7Helpers.escape.call(ctx_4, ctx_4.name, {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '</a>\n                                  </div>\n                                  <div class="list-full-top-right">\n                                    ';
                  r += Template7Helpers.formatPrice.call(ctx_4, ctx_4.salary.value, {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += ' ';
                  r += c(ctx_4.salary.currency, ctx_4);
                  r += '\n                                  </div>\n                                </div>\n                                <div class="list-full-bottom display-flex justify-content-space-between">\n                                  <div class="list-full-bottom-left min-width-0">\n                                    <div class="list-full-bottom-left-top">';
                  r += Template7Helpers.escape.call(ctx_4, ctx_4.team, {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '</div>\n                                    <div class="list-full-bottom-left-bottom">';
                  r += Template7Helpers.escape.call(ctx_4, ctx_4.position, {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '</div>\n                                  </div>\n                                  ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.pgp != \'0.00\'', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                    <div class="list-full-bottom-center text-align-right" style="margin-left: auto;">\n                                      <div class="list-full-bottom-center-top">';
                      r += c(ctx_5.pgp, ctx_5);
                      r += '</div>\n                                      <div class="list-full-bottom-center-bottom"><span class="param-wrapper"><span @click="infoPGP" class="info-icon"></span> <span>PGP</span></span></div>\n                                    </div>\n                                  ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                  ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.score_average != \'0.00\'', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                    <div class="list-full-bottom-center text-align-right">\n                                      <div class="list-full-bottom-center-top tour-6">';
                      r += c(ctx_5.score_average, ctx_5);
                      r += '</div>\n                                      <div class="list-full-bottom-center-bottom"><span class="param-wrapper"><span @click="infoPTS" class="info-icon"></span> <span>PTS</span></span></div>\n                                    </div>\n                                  ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                  </div>\n                                </div>\n                                <div class="item-after" @click="pickPlayer(\'';
                  r += c(ctx_4.id, ctx_4);
                  r += '\', 4)">\n                                  <i class="icon-plus-circle"></i>\n                                </div>\n                            </div>\n                        </div>\n                      </li>\n                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                  </ul>\n                </div>\n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          </div>\n          <!-- ТАБ 4 -->\n          <div id="duel-tab-4" class="page-content tab pt-0">\n            ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.duel, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n              <div class="players-box with-players-data">\n                <div class="box-row">\n                  ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.firstPlayer, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <div class="player-box first-player">\n                      ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.player.id != null', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <div class="body data">\n                          <div class="box">\n                            <div class="player-with-data">\n                              ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.player, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                <img src="';
                      r += c(ctx_5.image, ctx_5);
                      r += '" alt="">\n                              ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                            </div>\n                            <div class="description side">\n                              ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.player, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                <span class="name">\n                                  <span>';
                      r += c(ctx_5.h_firstname, ctx_5);
                      r += '</span>\n                                  <span>';
                      r += c(ctx_5.h_lastname, ctx_5);
                      r += '</span>\n                                </span>\n                              ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                              ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.match, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                <span class="match">\n                                  ';
                      r += Template7Helpers.js_if.call(ctx_5, 'this.myTeam == \'localteam\'', {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '<span class="bold">';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.localteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>';
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += '<span>';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.localteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>';
                          return r;
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += ' @ ';
                      r += Template7Helpers.js_if.call(ctx_5, 'this.myTeam == \'visitorteam\'', {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '<span class="bold">';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.visitorteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>';
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += '<span>';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.visitorteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>';
                          return r;
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                                </span>\n                                <span class="short-date">';
                      r += Template7Helpers.escape.call(ctx_5, ctx_5.shortDate, {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '</span>\n                              ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                            </div>\n                          </div>\n                         <!--  <div class="box">\n                            <div class="description bottom">\n                              <div class="details">\n                                ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.match, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                  <span class="match">\n                                    ';
                      r += Template7Helpers.js_if.call(ctx_5, 'this.myTeam == \'localteam\'', {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                      <span class="bold">';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.localteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>\n                                    ';
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                      <span>';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.localteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>\n                                    ';
                          return r;
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                                    -\n                                    ';
                      r += Template7Helpers.js_if.call(ctx_5, 'this.myTeam == \'visitorteam\'', {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                      <span class="bold">';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.visitorteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>\n                                    ';
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                      <span>';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.visitorteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>\n                                    ';
                          return r;
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                                  </span>\n                                  <span class="short-date">';
                      r += Template7Helpers.escape.call(ctx_5, ctx_5.shortDate, {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '</span>\n                                ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                              </div>\n                            </div>\n                          </div> -->\n                        </div>\n                      ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <div class="body">\n                          <div class="player" @click="pickDuelPlayer(1)">\n                            <i class="f7-icons">plus</i>\n                          </div>\n                          <div class="description" @click="pickDuelPlayer(1)">\n                            <span class="add-player-text">Добавить<br>игрока</span>\n                          </div>\n                        </div>\n                      ';
                  return r;
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                    </div>\n                  ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                  ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.secondPlayer, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <div class="player-box second-player">\n                      ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.player.id != null', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <div class="body data">\n                          <div class="box">\n                            <div class="description side">\n                              ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.player, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                <span class="name">\n                                  <span>';
                      r += c(ctx_5.h_firstname, ctx_5);
                      r += '</span>\n                                  <span>';
                      r += c(ctx_5.h_lastname, ctx_5);
                      r += '</span>\n                                </span>\n                              ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                              ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.match, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                <span class="match">\n                                  ';
                      r += Template7Helpers.js_if.call(ctx_5, 'this.myTeam == \'localteam\'', {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '<span class="bold">';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.localteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>';
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += '<span>';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.localteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>';
                          return r;
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += ' @ ';
                      r += Template7Helpers.js_if.call(ctx_5, 'this.myTeam == \'visitorteam\'', {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '<span class="bold">';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.visitorteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>';
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += '<span>';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.visitorteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>';
                          return r;
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                                </span>\n                                <span class="short-date">';
                      r += Template7Helpers.escape.call(ctx_5, ctx_5.shortDate, {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '</span>\n                              ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                            </div>\n                            <div class="player-with-data">\n                              ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.player, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                <img src="';
                      r += c(ctx_5.image, ctx_5);
                      r += '" alt="">\n                              ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                            </div>\n                          </div>\n                         <!--  <div class="box">\n                            <div class="description bottom">\n                              <div class="details">\n                                ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.player, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                  <div class="pointers">\n                                    ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.score_average, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                      <div class="pts pointer">\n                                        <span>PTS <span class="value">';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.score_average, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span></span>\n                                      </div>\n                                    ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                                    ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.rating, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                      <div class="pgp pointer">\n                                        <span>PGP <span class="value">';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.rating, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span></span>\n                                      </div>\n                                    ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                                  </div>\n                                ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.match, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                  <span class="match">\n                                    ';
                      r += Template7Helpers.js_if.call(ctx_5, 'this.myTeam == \'localteam\'', {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                      <span class="bold">';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.localteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>\n                                    ';
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                      <span>';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.localteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>\n                                    ';
                          return r;
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                                    -\n                                    ';
                      r += Template7Helpers.js_if.call(ctx_5, 'this.myTeam == \'visitorteam\'', {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                      <span class="bold">';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.visitorteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>\n                                    ';
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                      <span>';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.visitorteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>\n                                    ';
                          return r;
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                                  </span>\n                                  <span class="short-date">';
                      r += Template7Helpers.escape.call(ctx_5, ctx_5.shortDate, {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '</span>\n                                ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                              </div>\n                            </div>\n                          </div> -->\n                        </div>\n                      ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <div class="body">\n                          <div class="description" @click="pickDuelPlayer(2)">\n                            <span class="add-player-text">Добавить<br>игрока</span>\n                          </div>\n                          <div class="player" @click="pickDuelPlayer(2)">\n                            <i class="f7-icons">plus</i>\n                          </div>\n                        </div>\n                      ';
                  return r;
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                    </div>\n                  ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                </div>\n                <div class="box-row">\n                  <div class="player-box footer">\n                    <span class="disabled">Выбрать</span>\n                  </div>\n                  <div class="player-box footer">\n                    <span class="disabled">Выбрать</span>\n                  </div>\n                </div>\n              </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          </div>\n          <!-- ТАБ 5 -->\n          <div id="duel-tab-5" class="page-content tab pt-0">\n            ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.dataTabs, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n              ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.tab5, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <div class="calendar">\n                  ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.days, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                    <div class="day ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.toDay == true', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += 'today';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += ' ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.isActive == true', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += 'active';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '" @click="pickDay(\'';
                  r += c(ctx_4.day, ctx_4);
                  r += '\')">\n                      <div class="content">\n                        <span>';
                  r += c(ctx_4.text, ctx_4);
                  r += '</span>\n                        <span>';
                  r += c(ctx_4.day, ctx_4);
                  r += '</span>\n                      </div>\n                    </div>\n                  ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                </div>\n                <div class="matches">\n                  <div class="title">Выберите матч</div>\n                  <div class="list list-matches accordion-list accordion-opposite">\n                    <ul class="leagues">\n                      ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.leagues, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <li class="accordion-item"><a class="item-content item-link" href="#">\n                            <div class="item-inner">\n                              <div class="item-title">';
                  r += c(ctx_4.name, ctx_4);
                  r += '</div>\n                            </div>\n                          </a>\n                          <div class="accordion-item-content">\n                            <ul class="matches">\n                              ';
                  r += Template7Helpers.each.call(ctx_4, ctx_4.matches, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                <li id="match-';
                      r += c(ctx_5.id, ctx_5);
                      r += '" class="match" @click="pickMatch(\'';
                      r += c(ctx_5.id, ctx_5);
                      r += '\')">\n                                  <div class="match-row">\n                                    <label class="radio item-radio" @click="preventEvent">\n                                      <input type="radio" name="match-tab5" value="';
                      r += c(ctx_5.id, ctx_5);
                      r += '">\n                                      <i class="icon-radio"></i>\n                                    </label>\n                                    <div class="match-block">\n                                      <span class="match-title">';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.is_virtual, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '<span>*</span>';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += c(ctx_5.localteam, ctx_5);
                      r += ' - ';
                      r += c(ctx_5.visitorteam, ctx_5);
                      r += '</span>\n                                      <span class="match-data">';
                      r += c(ctx_5.shortDate, ctx_5);
                      r += '</span>\n                                    </div>\n                                  </div>\n                                </li>\n                              ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                            </ul>\n                          </div>\n                        </li>\n                      ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                    </ul>\n                  </div>\n                </div>\n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          </div>\n          <!-- ТАБ 6 -->\n          <div id="duel-tab-6" class="page-content tab pt-0">\n            ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.dataTabs, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n              ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.tab6, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <div class="filter-row">\n                  <a href="#" class="link popover-open" data-popover="#popover-matches-filter-tab6">\n                    <span id="filter-title">Команда</span>\n                    <i class="f7-icons icon">chevron_down</i>\n                  </a>\n                  <a href="#" class="link popover-open" data-popover="#popover-sort-tab6">\n                    <span id="sort-title">Роль</span>\n                    <i class="f7-icons icon">chevron_down</i>\n                  </a>\n                  <a href="#" class="link popover-open" data-popover="#popover-sort-details-tab6">\n                    <span id="sort-detaile-title">Роль</span>\n                    <i class="f7-icons icon">chevron_down</i>\n                  </a>\n                </div>\n                <div class="list players no-chevron">\n                  <ul>\n                    ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.players, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                      <li class="bg-color-white">\n                        <div class="item-content list-full-content">\n                            <div class="item-media">\n                                <a class="item-media__face" href="#">\n                                    <img src="';
                  r += c(ctx_4.image, ctx_4);
                  r += '" class="game-avatar">\n                                    ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.in_lineups, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                        <span class="item-media__in_lineups tour-7"></span>\n                                    ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.is_injured, {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      return r;
                    },
                    inverse: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                        ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.is_injured, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                            <span class="item-media__is_injured tour-7"></span>\n                                        ';
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                            <span class="tour-7"></span>\n                                        ';
                          return r;
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                                    ';
                      return r;
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                </a>\n                            </div>\n                            <div class="item-inner">\n                              <div class="width-100 min-width-0">\n                                <div class="list-full-top display-flex justify-content-space-between align-content-center">\n                                  <div class="list-full-top-left">\n                                    ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.is_having_stats, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                      <i class="icon icon-player-has-stat" style="margin-top: -3px;"></i>\n                                    ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                      <a href="/player/info?player_id=';
                  r += c(ctx_4.id, ctx_4);
                  r += '">';
                  r += Template7Helpers.escape.call(ctx_4, ctx_4.name, {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '</a>\n                                  </div>\n                                  <div class="list-full-top-right">\n                                    ';
                  r += Template7Helpers.formatPrice.call(ctx_4, ctx_4.salary.value, {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += ' ';
                  r += c(ctx_4.salary.currency, ctx_4);
                  r += '\n                                  </div>\n                                </div>\n                                <div class="list-full-bottom display-flex justify-content-space-between">\n                                  <div class="list-full-bottom-left min-width-0">\n                                    <div class="list-full-bottom-left-top">';
                  r += Template7Helpers.escape.call(ctx_4, ctx_4.team, {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '</div>\n                                    <div class="list-full-bottom-left-bottom">';
                  r += Template7Helpers.escape.call(ctx_4, ctx_4.position, {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '</div>\n                                  </div>\n                                  ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.pgp != \'0.00\'', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                    <div class="list-full-bottom-center text-align-right" style="margin-left: auto;">\n                                      <div class="list-full-bottom-center-top">';
                      r += c(ctx_5.pgp, ctx_5);
                      r += '</div>\n                                      <div class="list-full-bottom-center-bottom"><span class="param-wrapper"><span @click="infoPGP" class="info-icon"></span> <span>PGP</span></span></div>\n                                    </div>\n                                  ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                  ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.score_average != \'0.00\'', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                    <div class="list-full-bottom-center text-align-right">\n                                      <div class="list-full-bottom-center-top tour-6">';
                      r += c(ctx_5.score_average, ctx_5);
                      r += '</div>\n                                      <div class="list-full-bottom-center-bottom"><span class="param-wrapper"><span @click="infoPTS" class="info-icon"></span> <span>PTS</span></span></div>\n                                    </div>\n                                  ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                  </div>\n                                </div>\n                                <div class="item-after" @click="pickPlayer(\'';
                  r += c(ctx_4.id, ctx_4);
                  r += '\', 7)">\n                                  <i class="icon-plus-circle"></i>\n                                </div>\n                            </div>\n                        </div>\n                      </li>\n                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                  </ul>\n                </div>\n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          </div>\n          <!-- ТАБ 7 -->\n          <div id="duel-tab-7" class="page-content tab pt-0">\n            <div class="header">\n              <span class="title">Выберите игрока</span>\n              <span class="subtitle">Ваш соперник выберет противоположного игрока</span>\n            </div>\n            ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.duel, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n              <div class="players-box with-players-data">\n                <div class="box-row">\n                  ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.firstPlayer, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <div class="player-box first-player">\n                      ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.player.id != null', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <div class="body data">\n                          <div class="box">\n                            <div class="player-with-data">\n                              ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.player, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                <img src="';
                      r += c(ctx_5.image, ctx_5);
                      r += '" alt="">\n                              ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                            </div>\n                            <div class="description side">\n                              ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.player, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                <span class="name">\n                                  <span>';
                      r += c(ctx_5.h_firstname, ctx_5);
                      r += '</span>\n                                  <span>';
                      r += c(ctx_5.h_lastname, ctx_5);
                      r += '</span>\n                                </span>\n                              ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                              ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.match, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                <span class="match">\n                                  ';
                      r += Template7Helpers.js_if.call(ctx_5, 'this.myTeam == \'localteam\'', {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '<span class="bold">';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.localteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>';
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += '<span>';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.localteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>';
                          return r;
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += ' @ ';
                      r += Template7Helpers.js_if.call(ctx_5, 'this.myTeam == \'visitorteam\'', {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '<span class="bold">';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.visitorteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>';
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += '<span>';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.visitorteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>';
                          return r;
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                                </span>\n                                <span class="short-date">';
                      r += Template7Helpers.escape.call(ctx_5, ctx_5.shortDate, {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '</span>\n                              ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                            </div>\n                          </div>\n                        </div>\n                      ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <div class="body">\n                          <div class="player" @click="pickDuelPlayer(1)">\n                            <i class="f7-icons">plus</i>\n                          </div>\n                          <div class="description" @click="pickDuelPlayer(1)">\n                            <span class="add-player-text">Добавить<br>игрока</span>\n                          </div>\n                        </div>\n                      ';
                  return r;
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                    </div>\n                  ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                  ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.secondPlayer, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <div class="player-box second-player">\n                      ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.player.id != null', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <div class="body data">\n                          <div class="box">\n                            <div class="description side">\n                              ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.player, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                <span class="name">\n                                  <span>';
                      r += c(ctx_5.h_firstname, ctx_5);
                      r += '</span>\n                                  <span>';
                      r += c(ctx_5.h_lastname, ctx_5);
                      r += '</span>\n                                </span>\n                              ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                              ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.match, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                <span class="match">\n                                  ';
                      r += Template7Helpers.js_if.call(ctx_5, 'this.myTeam == \'localteam\'', {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '<span class="bold">';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.localteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>';
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += '<span>';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.localteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>';
                          return r;
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += ' @ ';
                      r += Template7Helpers.js_if.call(ctx_5, 'this.myTeam == \'visitorteam\'', {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '<span class="bold">';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.visitorteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>';
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += '<span>';
                          r += Template7Helpers.escape.call(ctx_6, ctx_6.visitorteam, {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '</span>';
                          return r;
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                                </span>\n                                <span class="short-date">';
                      r += Template7Helpers.escape.call(ctx_5, ctx_5.shortDate, {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '</span>\n                              ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                            </div>\n                            <div class="player-with-data">\n                              ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.player, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                <img src="';
                      r += c(ctx_5.image, ctx_5);
                      r += '" alt="">\n                              ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                            </div>\n                          </div>\n                        </div>\n                      ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <div class="body">\n                          <div class="description" @click="pickDuelPlayer(2)">\n                            <span class="add-player-text">Добавить<br>игрока</span>\n                          </div>\n                          <div class="player" @click="pickDuelPlayer(2)">\n                            <i class="f7-icons">plus</i>\n                          </div>\n                        </div>\n                      ';
                  return r;
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                    </div>\n                  ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                </div>\n                <div class="box-row">\n                  ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.userSelectPlayer == true', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <div class="saved-duel">\n                      ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.myPlayer.t == \'first\'', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <div class="player first-player">\n                          ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.myPlayer, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                            <div class="me" @click="selectMyPlayer(\'first\')">\n                              ';
                      r += Template7Helpers.with.call(ctx_5, ctx_5.me, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                <img class="avatar" src="';
                          r += c(ctx_6.avatar.url, ctx_6);
                          r += '" alt="">\n                                <div class="info">\n                                  <span class="name">';
                          r += c(ctx_6.name, ctx_6);
                          r += '</span>\n                                  ';
                          r += Template7Helpers.with.call(ctx_6, ctx_6.priz, {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += '\n                                    <span class="cost">';
                              r += c(ctx_7.amount, ctx_7);
                              r += '<i class="fas fa-star"></i></span>\n                                  ';
                              return r;
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '\n                                </div>\n                              ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                            </div>\n                          ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                        </div>\n                        <div class="player second-player">\n                          ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.secondPlayer, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                            ';
                      r += Template7Helpers.with.call(ctx_5, ctx_5.player, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                              <div class="without-data" @click="selectMyPlayer(\'';
                          r += c(ctx_6.id, ctx_6);
                          r += '\')">\n                                <span>Выбрать</span>\n                              </div>\n                            ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                          ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                        </div>\n                      ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <div class="player first-player">\n                          ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.firstPlayer, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                            ';
                      r += Template7Helpers.with.call(ctx_5, ctx_5.player, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                              <div class="without-data" @click="selectMyPlayer(\'';
                          r += c(ctx_6.id, ctx_6);
                          r += '\')">\n                                <span>Выбрать</span>\n                              </div>\n                            ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                          ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                        </div>\n                        <div class="player second-player">\n                          ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.myPlayer, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                            <div class="me" @click="selectMyPlayer(\'second\')">\n                              ';
                      r += Template7Helpers.with.call(ctx_5, ctx_5.me, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                <div class="me">\n                                  <div class="info">\n                                    <span class="name">';
                          r += c(ctx_6.name, ctx_6);
                          r += '</span>\n                                    ';
                          r += Template7Helpers.with.call(ctx_6, ctx_6.priz, {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += '\n                                      <span class="cost">';
                              r += c(ctx_7.amount, ctx_7);
                              r += '<i class="fas fa-star"></i></span>\n                                    ';
                              return r;
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '\n                                  </div>\n                                  <img class="avatar" src="';
                          r += c(ctx_6.avatar.url, ctx_6);
                          r += '" alt="">\n                                </div>\n                              ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                            </div>\n                          ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                        </div>\n                      ';
                  return r;
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                    </div>\n                  ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    ';
              r += Template7Helpers.with.call(ctx_3, ctx_3.firstPlayer, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                      ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.player, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                        <div class="player-box footer" @click="selectMyPlayer(\'';
                      r += c(ctx_5.id, ctx_5);
                      r += '\')">\n                          <span class="">Выбрать</span>\n                        </div>\n                        ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                    ';
              r += Template7Helpers.with.call(ctx_3, ctx_3.secondPlayer, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                      ';
                  r += Template7Helpers.with.call(ctx_4, ctx_4.player, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                        <div class="player-box footer" @click="selectMyPlayer(\'';
                      r += c(ctx_5.id, ctx_5);
                      r += '\')">\n                          <span class="">Выбрать</span>\n                        </div>\n                      ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                  ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                </div>\n              </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          </div>\n        </div>\n      </div>\n\n      <!-- Модальное окно с кнопкой "Дальше" -->\n      <div class="sheet-modal sheet-save-btn">\n        <div class="sheet-modal-inner">\n          <div class="page-content">\n            <div class="block">\n              <button class="button success" @click="next">Дальше</button>\n            </div>\n          </div>\n        </div>\n      </div>\n      <!-- Модальное окно с кнопкой "Создать дуэль" -->\n      <div class="sheet-modal sheet-сreate-duel-btn">\n        <div class="sheet-modal-inner">\n          <div class="page-content">\n              <div class="block">\n                ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.duel, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                  ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.userSelectPlayer, {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                    ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.userSelectPlayer == true', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                      <button class="button success" @click="createDuel">Создать дуэль</button>\n                    ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                      <button class="button success disable" @click="viewAlertSelectPlayer">Создать дуэль</button>\n                    ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                  ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <button class="button success disable">Создать дуэль</button>\n                  ';
          r += '\n                ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <!-- Модальное окно с суммой дуэли -->\n      <div class="sheet-modal sheet-finish-duel">\n        <div class="sheet-modal-inner">\n          <div class="page-content">\n            <div class="block">\n              <div class="header">\n                ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.selectedPlayer, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                  ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.player, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <span class="player-name">';
              r += Template7Helpers.escape.call(ctx_3, ctx_3.h_name, {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '</span>\n                    <span class="player-description">ваш соперник выберет противоположного игрока</span>\n                  ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n              </div>\n              <div class="selected">\n                <div class="context">\n                  <div class="minus" @click="minus">\n                    <i class="icon icon-minus-svg"></i>\n                  </div>\n                  <div class="amount">\n                    ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.finishState, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                      <input type="number" class="total" name="amount" pattern="[0-9]*" value="';
          r += c(ctx_2.amount, ctx_2);
          r += '" @change="updateTotal">\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    <span class="hint">Сумма взноса</span>\n                  </div>\n                  <div class="plus" @click="plus">\n                    <i class="icon icon-plus-svg"></i>\n                  </div>\n                </div>\n              </div>\n              <div class="details">\n                <div class="commission">\n                  ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.finishState, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <span class="count">';
          r += c(ctx_2.priz, ctx_2);
          r += '<i class="fas fa-star"></i></span>\n                  ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                  <span class="text">Возможный выигрыш</span>\n                </div>\n               <!--  <div class="priz">\n                  ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.finishState, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <span class="count">';
          r += c(ctx_2.priz, ctx_2);
          r += '<i class="fas fa-star"></i></span>\n                  ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                  <span class="text">Возможный выигрыш</span>\n                </div> -->\n              </div>\n            </div>\n\n            <div class="footer">\n              <button class="button" @click="saveDuel">Сохранить</button>\n            </div>\n          </div>\n        </div>\n      </div>\n      ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.dataTabs, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.tab3, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n          <div class="popover" id="popover-matches-filter-tab3">\n            <div class="popover-angle"></div>\n            <div class="popover-inner">\n              ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.matches, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                <div class="list">\n                <ul>\n                  ';
                  r += Template7Helpers.each.call(ctx_4, ctx_4.matches, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                    <li>\n                      <label class="item-radio item-content">\n                        <input @change="selectMatchTab3" type="radio" name="command-filter-tab3" data-title="';
                      r += c(ctx_5.title, ctx_5);
                      r += '" value="';
                      r += c(ctx_5.value, ctx_5);
                      r += '" ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.selected, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += ' checked ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += ' />\n                        <i class="icon icon-radio"></i>\n                        <div class="item-inner">\n                          <div class="item-title">\n                            ';
                      r += Template7Helpers.escape.call(ctx_5, ctx_5.title, {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                          </div>\n                        </div>\n                      </label>\n                    </li>\n                  ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                </ul>\n              </div>\n            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n          </div>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n      ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n      ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.dataTabs, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.tab6, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n          <div class="popover" id="popover-matches-filter-tab6">\n            <div class="popover-angle"></div>\n            <div class="popover-inner">\n              ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.matches, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                <div class="list">\n                <ul>\n                  ';
                  r += Template7Helpers.each.call(ctx_4, ctx_4.matches, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                    <li>\n                      <label class="item-radio item-content">\n                        <input @change="selectMatchTab6" type="radio" name="command-filter-tab6" data-title="';
                      r += c(ctx_5.title, ctx_5);
                      r += '" value="';
                      r += c(ctx_5.value, ctx_5);
                      r += '" ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.selected, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += ' checked ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += ' />\n                        <i class="icon icon-radio"></i>\n                        <div class="item-inner">\n                          <div class="item-title">\n                            ';
                      r += Template7Helpers.escape.call(ctx_5, ctx_5.title, {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                          </div>\n                        </div>\n                      </label>\n                    </li>\n                  ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                </ul>\n              </div>\n            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n          </div>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n      ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n      ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.dataTabs, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.tab3, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n          <div class="popover" id="popover-sort-details-tab3">\n            <div class="popover-angle"></div>\n            <div class="popover-inner">\n              ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.sortDetails, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                <div class="list">\n                <ul>\n                  ';
                  r += Template7Helpers.each.call(ctx_4, ctx_4.sortDetails, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                    <li>\n                      <label class="item-radio item-content">\n                        <input @change="selectSortDetailTab3" type="radio" name="sort-details-tab3" data-title="';
                      r += c(ctx_5.title, ctx_5);
                      r += '" value="';
                      r += c(ctx_5.value, ctx_5);
                      r += '" ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.selected, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += ' checked ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += ' />\n                        <i class="icon icon-radio"></i>\n                        <div class="item-inner">\n                          <div class="item-title">\n                            ';
                      r += Template7Helpers.escape.call(ctx_5, ctx_5.title, {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                          </div>\n                        </div>\n                      </label>\n                    </li>\n                  ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                </ul>\n              </div>\n            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n          </div>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n      ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n      ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.dataTabs, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.tab6, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n          <div class="popover" id="popover-sort-details-tab6">\n            <div class="popover-angle"></div>\n            <div class="popover-inner">\n              ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.sortDetails, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                <div class="list">\n                <ul>\n                  ';
                  r += Template7Helpers.each.call(ctx_4, ctx_4.sortDetails, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                    <li>\n                      <label class="item-radio item-content">\n                        <input @change="selectSortDetailTab6" type="radio" name="sort-details-tab6" data-title="';
                      r += c(ctx_5.title, ctx_5);
                      r += '" value="';
                      r += c(ctx_5.value, ctx_5);
                      r += '" ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.selected, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += ' checked ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += ' />\n                        <i class="icon icon-radio"></i>\n                        <div class="item-inner">\n                          <div class="item-title">\n                            ';
                      r += Template7Helpers.escape.call(ctx_5, ctx_5.title, {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                          </div>\n                        </div>\n                      </label>\n                    </li>\n                  ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                </ul>\n              </div>\n            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n          </div>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n      ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n      ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.dataTabs, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.tab3, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n          <div class="popover" id="popover-sort-tab3">\n            <div class="popover-angle"></div>\n            <div class="popover-inner">\n              ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.positions, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                <div class="list">\n                <ul>\n                  ';
                  r += Template7Helpers.each.call(ctx_4, ctx_4.positions, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                    <li>\n                      <label class="item-radio item-content">\n                        <input @change="selectPositionTab3" type="radio" name="sort" data-title="';
                      r += c(ctx_5.title, ctx_5);
                      r += '" value="';
                      r += c(ctx_5.value, ctx_5);
                      r += '" ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.selected, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += ' checked ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += ' />\n                        <i class="icon icon-radio"></i>\n                        <div class="item-inner">\n                          <div class="item-title">\n                            ';
                      r += Template7Helpers.escape.call(ctx_5, ctx_5.title, {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                          </div>\n                        </div>\n                      </label>\n                    </li>\n                  ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                </ul>\n              </div>\n            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n          </div>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n      ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n      ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.dataTabs, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.tab6, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n          <div class="popover" id="popover-sort-tab6">\n            <div class="popover-angle"></div>\n            <div class="popover-inner">\n              ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.positions, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                <div class="list">\n                <ul>\n                  ';
                  r += Template7Helpers.each.call(ctx_4, ctx_4.positions, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                    <li>\n                      <label class="item-radio item-content">\n                        <input @change="selectPositionTab6" type="radio" name="sort2" data-title="';
                      r += c(ctx_5.title, ctx_5);
                      r += '" value="';
                      r += c(ctx_5.value, ctx_5);
                      r += '" ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.selected, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += ' checked ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += ' />\n                        <i class="icon icon-radio"></i>\n                        <div class="item-inner">\n                          <div class="item-title">\n                            ';
                      r += Template7Helpers.escape.call(ctx_5, ctx_5.title, {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                          </div>\n                        </div>\n                      </label>\n                    </li>\n                  ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                </ul>\n              </div>\n            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n          </div>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n      ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n    </div>\n  </div>\n';
      return r;
    }(this);
  },
  style: `
  .duel-tabs {
    height: unset;
  }
  .duel-tabs > .tabs > .tab {
    padding-bottom: 0px;
  }
  .duel-tabs > .tabs .list.players {
    overflow: auto;
  }
  .duel-tabs > .tabs > #duel-tab-2,
  .duel-tabs > .tabs > #duel-tab-4 {
    padding-bottom: 79px;
  }
  .duel-creation-page .page-content {
    padding-bottom: 0px;
    overflow: hidden;
  }
  /* Модалка с суммой */
  .sheet-finish-duel {
    background: transparent;
    height: calc(292px + var(--f7-safe-area-bottom));
    overflow: hidden;
  }
  .sheet-finish-duel .page-content {
    background-color: #EFEEF3;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  }
  .sheet-finish-duel .block {
    margin-top: 16px;
  }
  .sheet-finish-duel .header {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
  }
  .sheet-finish-duel .header .player-name {
    font-style: normal;
    font-weight: bold;
    font-size: 28px;
    line-height: 34px;
    letter-spacing: 0.337647px;
    color: #445058;
  }
  .sheet-finish-duel .header .player-name + .player-description {
    margin-top: 8px;
  }
  .sheet-finish-duel .header .player-description {
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 13px;
    letter-spacing: 0.07px;
    text-transform: uppercase;
    color: #818E95;
  }
  .sheet-finish-duel .selected .context {
    background-color: #ffffff;
    height: 56px;
    border-radius: 8px;
    display: flex;
    border: 1px solid #CFD6DB;
  }
  .sheet-finish-duel .selected .context .minus {
    width: 25%;
    height: inherit;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-right: 1px solid #CFD6DB;
  }
  .sheet-finish-duel .selected .context .amount {
    width: 50%;
    height: inherit;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .sheet-finish-duel .selected .context .amount .total {
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 20px;
    letter-spacing: 0.38px;
    color: #445058;
    width: inherit;
    text-align: center;
  }
  .sheet-finish-duel .selected .context .amount .total + .hint {
    margin-top: 2px;
  }
  .sheet-finish-duel .selected .context .amount .hint {
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 10px;
    letter-spacing: 0.07px;
    text-transform: uppercase;
    color: #818E95;
  }
  .sheet-finish-duel .selected .context .plus {
    width: 25%;
    height: inherit;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-left: 1px solid #CFD6DB;
  }
  .sheet-finish-duel .details {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
  }
  .sheet-finish-duel .details .commission {
    display: flex;
    flex-direction: column;
  }
  .sheet-finish-duel .details .priz {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .sheet-finish-duel .details .commission .count {
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.41px;
    color: #445058;
    display: flex;
    align-items: center;
  }
  .sheet-finish-duel .details .commission .count + .text {
    margin-top: 2px;
  }
  .sheet-finish-duel .details .commission .text {
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 13px;
    letter-spacing: 0.07px;
    text-transform: uppercase;
    color: #818E95;
  }
  .sheet-finish-duel .details .priz .count {
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.41px;
    color: #445058;
  }
  .sheet-finish-duel .details .priz .count + .text {
    margin-top: 4px;
  }
  .sheet-finish-duel .details .priz .text {
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 13px;
    letter-spacing: 0.07px;
    text-transform: uppercase;
    color: #818E95;
  }
  .sheet-finish-duel hr {
    margin-top: 16px;
    border-bottom: 1px solid #000000;
    border-width: thin;
    border-top: none;
    opacity: 0.3;
    margin-bottom: 16px;
  }
  .sheet-finish-duel .footer {
    width: calc(100% - 32px);
    margin-top: 28px;
    margin-bottom: calc(16px + var(--f7-safe-area-bottom));
  }
  .sheet-finish-duel .footer button {
    margin-left: 16px;
    margin-right: 16px;
    height: 46px;
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    line-height: 17px;
    letter-spacing: -0.41px;
    color: #FFFFFF;
    background-color: #007AFF;
  }
  /* Таб 4 */
  .duel-tabs #duel-tab-4 .players-box {
    margin-top: 32px;
  }
  /* Таб 7 */
  .duel-tabs #duel-tab-7 .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 16px;
  }
  .duel-tabs #duel-tab-7 .header .title {
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.41px;
    color: #445058;
  }
  .duel-tabs #duel-tab-7 .header .subtitle {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.08px;
    color: #818E95;
  }
  .duel-tabs #duel-tab-7 .header .title + .subtitle {
    margin-top: 8px;
  }
  .duel-tabs #duel-tab-7 .players-box .player-box .footer span {
    font-size: 15px;
    line-height: 15px;
    letter-spacing: -0.24px;
    color: #007AFF;
  }
  /* .duel-tabs #duel-tab-7 .players-box {
    background: #FFFFFF;
    border: 1px solid #CFD6DB;
    border-radius: 9px;
    display: flex;
  }

  .duel-tabs #duel-tab-7 .players-box .player-box {
    display: flex;
    flex-direction: column;
    width: 50%;
  }
  .duel-tabs #duel-tab-7 .players-box .player-box + .player-box {
    border-left: 1px solid #CFD6DB;
    border-width: thin;
  }
  .duel-tabs #duel-tab-7 .players-box .player-box .body {
    background-color: #ffffff;
    height: 108px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .duel-tabs #duel-tab-7 .players-box .player-box .body .player {
    width: 50px;
    height: 50px;
    border: 1px dashed #CFD6DB;
    border-radius: 5px;
    background-color: #F0F3F8;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .duel-tabs #duel-tab-7 .players-box .player-box .body .player i {
    color: #CFD6DB;
  }
  .duel-tabs #duel-tab-7 .players-box .player-box .body .player + .description {
    margin-left: 12px;
  }
  .duel-tabs #duel-tab-7 .players-box .player-box .body .description + .player {
    margin-left: 12px;
  }


  .duel-tabs #duel-tab-7 .players-box .player-box .body .description span {
    font-weight: 600;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: -0.08px;
    color: #007AFF;
  }
  .duel-tabs #duel-tab-7 .players-box .player-box:nth-child(1) .body .description {
    text-align: left;
  }
  .duel-tabs #duel-tab-7 .players-box .player-box:nth-child(2) .body .description {
    text-align: right;
  }


  .duel-tabs #duel-tab-7 .players-box .player-box:nth-child(1) .body {
    border-top-left-radius: 9px;
  }
  .duel-tabs #duel-tab-7 .players-box .player-box:nth-child(2) .body {
    border-top-right-radius: 9px;
  }

  .duel-tabs #duel-tab-7 .players-box .player-box .body + .footer {
    border-top: 1px solid #CFD6DB;
    border-width: thin;
  }

  .duel-tabs #duel-tab-7 .players-box .player-box .footer {
    background-color: #F5F8FC;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .duel-tabs #duel-tab-7 .players-box .player-box:nth-child(1) .footer {
    border-bottom-left-radius: 9px;
    color: #007AFF;
  }
  .duel-tabs #duel-tab-7 .players-box .player-box:nth-child(2) .footer {
    border-bottom-right-radius: 9px;
    color: #007AFF;
  }
  .duel-tabs #duel-tab-7 .players-box .player-box .footer span.disabled {
    font-size: 15px;
    line-height: 15px;
    letter-spacing: -0.24px;
    color: #CFD6DB;
  } */
  /* Таб 6 */
  .duel-tabs #duel-tab-6 .filter-row {
    display: flex;
    background-color: #ffffff;
    height: 44px;
    width: calc(100% - 40px);
    align-items: center;
    justify-content: space-between;
    padding: 0px 20px;
    position: relative;
    z-index: 999;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
  }
  .duel-tabs #duel-tab-6 .filter-row a {
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.41px;
    color: var(--f7-navbar-bg-color);
    display: flow-root;
  }
  .duel-tabs #duel-tab-6 .filter-row a i {
    font-size: 18px;
    margin-left: 2px;
  }
  .duel-tabs #duel-tab-6 .players {
    --f7-list-bg-color: F0F3F8;
    --f7-list-item-title-line-height: 100px;
    --f7-list-item-padding-vertical: 0;
    margin-top: 0px;
  }

  .duel-tabs #duel-tab-6 .players .item-title {
    color: #445058;
  }

  .duel-tabs #duel-tab-6 .players .list-full-bottom-left-top{
    font-size: 14px;
    color: #445058;
    white-space: nowrap;
    overflow: hidden;
    height: 1.3em;
    text-overflow: ellipsis;
  }
  .duel-tabs #duel-tab-6 .players .list-full-bottom-left-bottom{
    font-size: 11px;
    color: #818E95;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .duel-tabs #duel-tab-6 .players .list-full-bottom-center {
    min-width: 46px;
  }
  .duel-tabs #duel-tab-6 .players .list-full-bottom-center-top{
    font-size: 14px;
    color: #445058;
    font-weight: 500;
    text-transform:uppercase;
  }
  .duel-tabs #duel-tab-6 .players .list-full-bottom-center-bottom{
    font-size: 11px;
    color: #818E95;
    text-transform:uppercase;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .duel-tabs #duel-tab-6 .players .list-full-bottom-center-bottom img{
    width: 11px;
    height: 11px;
    position: relative;
  }

  .duel-tabs #duel-tab-6 .players .list-full-bottom-right-top{
    font-size: 14px;
    color: #445058;
    font-weight: 500;
    text-transform:uppercase;
  }
  .duel-tabs #duel-tab-6 .players .list-full-bottom-right-bottom{
    font-size: 11px;
    color: #818E95;
    text-transform:uppercase;
  }

  .duel-tabs #duel-tab-6 .players .list-full-content{
    height: 100px;
  }

  .duel-tabs #duel-tab-6 .players .list-full-top{
    height: 29px;
    flex-direction: row;
    padding-right: 10px;

  }
  .duel-tabs #duel-tab-6 .players .list-full-bottom{
    height: 33px;
    padding-right: 10px;
  }
  .duel-tabs #duel-tab-6 .players .list-full-top-left{
    font-size: 15px;
    color: #007AFF;
    white-space: nowrap;
    overflow: hidden;
    height: 1.3em;
    text-overflow: ellipsis;
  }
  .duel-tabs #duel-tab-6 .players .list-full-top-right{
    position: relative;
    top: 0;
    text-align: right;
    flex-shrink: 0;
  }

  .duel-tabs #duel-tab-6 .players .list-full-top-right{
    font-weight: bold;
    color: #445058;
  }
  /* Таб 5 */
  .duel-tabs #duel-tab-5 .calendar {
    height: 47px;
    display: flex;
    flex-direction: row;
  }
  .duel-tabs #duel-tab-5 .calendar .day {
    background-color: #E6E6E6;
    width: 100%;
    height: 45px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .duel-tabs #duel-tab-2 .calendar .day + .day {
/*     border-left: 1px solid #E6E6E6;
    border-width: thin; */
  }
  .duel-tabs #duel-tab-5 .calendar .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    height: 100%;
    width: 100%;
    margin: 1px;
  }
  .duel-tabs #duel-tab-5 .calendar .day span:nth-child(1) {
    font-weight: 300;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.07px;
    text-transform: uppercase;
    color: #15367A;
  }
  .duel-tabs #duel-tab-5 .calendar .day span:nth-child(2) {
    font-weight: 300;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: -0.24px;
    color: #15367A;
  }
  .duel-tabs #duel-tab-5 .calendar .day.today span {
    font-weight: bold;
  }
  .duel-tabs #duel-tab-5 .calendar .day.active::after {
    content: '';
    position: absolute;
    background-color: var(--f7-navbar-bg-color);
    display: block;
    z-index: 15;
    top: auto;
    right: auto;
    bottom: 0;
    left: 0;
    height: 3px;
    width: 100%;
    transform-origin: 50% 100%;
    transform: scaleY(calc(1 / 1));
    transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
  }
  .duel-tabs #duel-tab-5 .calendar .day.active .content {
    background-color: #F3F3F3;
  }
  .duel-tabs #duel-tab-5 .matches {
    overflow: auto;
    margin-top: 0px;
  }
  .duel-tabs #duel-tab-5 .matches .title {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: -0.08px;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.4);
    padding-top: 24px;
    margin: 0px 16px 8px;
  }
  .duel-tabs #duel-tab-5 .matches .list .accordion-item .item-content:after {
    content: '';
    position: absolute;
    background-color: var(--f7-list-border-color);
    display: block;
    z-index: 15;
    top: auto;
    right: auto;
    bottom: 0;
    left: 0;
    height: 1px;
    width: 100%;
    transform-origin: 50% 100%;
    transform: scaleY(calc(1 / 1));
    transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
  }
  .duel-tabs #duel-tab-5 .matches .accordion-list li:after {
    content: '';
    position: absolute;
    background-color: var(--f7-list-border-color);
    display: block;
    z-index: 15;
    top: auto;
    right: auto;
    bottom: 0;
    left: 0;
    height: 1px;
    width: 100%;
    transform-origin: 50% 100%;
    transform: scaleY(calc(1 / 1));
    transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
  }
  .duel-tabs #duel-tab-5 .matches .list .accordion-item .item-content .item-title {
    color: #000000;
  }

  .duel-tabs #duel-tab-5 .matches .accordion-list li .match-row {
    align-items: center;
    display: flex;
    height: 60px;
    margin-left: 16px;
  }
  .duel-tabs #duel-tab-5 .matches .accordion-list li .match-row .match-title {
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 17px;
    letter-spacing: -0.41px;
    color: #000000;
  }
  .duel-tabs #duel-tab-5 .matches .accordion-list li .match-row .match-title + .match-data {
    margin-top: 4px;
  }
  .duel-tabs #duel-tab-5 .matches .accordion-list li .match-row .match-data {
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 15px;
    letter-spacing: -0.24px;
    color: #8C8C8C;
  }
  .duel-tabs #duel-tab-5 .matches .accordion-list li .match-row .radio {
    margin-right: 16px;
  }
  .duel-tabs #duel-tab-5 .matches .accordion-list li .match-row .item-radio i {
    position: unset;
    top: unset;
    margin-top: unset;
    right: unset;
  }
  .duel-tabs #duel-tab-5 .matches .accordion-list li .match-row .match-block {
    display: flex;
    flex-direction: column;
  }
  /* Таб 3 */
  .duel-tabs #duel-tab-3 .filter-row {
    display: flex;
    background-color: #ffffff;
    height: 44px;
    width: calc(100% - 40px);
    align-items: center;
    justify-content: space-between;
    padding: 0px 20px;
    position: relative;
    z-index: 999;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
  }
  .duel-tabs #duel-tab-3 .filter-row a {
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.41px;
    color: var(--f7-navbar-bg-color);
    display: flow-root;
  }
  .duel-tabs #duel-tab-3 .filter-row a i {
    font-size: 18px;
    margin-left: 2px;
  }
  .duel-tabs #duel-tab-3 .players {
    --f7-list-bg-color: F0F3F8;
    --f7-list-item-title-line-height: 100px;
    --f7-list-item-padding-vertical: 0;
    margin-top: 0px;
  }

  .duel-tabs #duel-tab-3 .players .item-title {
    color: #445058;
  }

  .duel-tabs #duel-tab-3 .players .list-full-bottom-left-top{
    font-size: 14px;
    color: #445058;
    white-space: nowrap;
    overflow: hidden;
    height: 1.3em;
    text-overflow: ellipsis;
  }
  .duel-tabs #duel-tab-3 .players .list-full-bottom-left-bottom{
    font-size: 11px;
    color: #818E95;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .duel-tabs #duel-tab-3 .players .list-full-bottom-center {
    min-width: 46px;
  }
  .duel-tabs #duel-tab-3 .players .list-full-bottom-center-top{
    font-size: 14px;
    color: #445058;
    font-weight: 500;
    text-transform:uppercase;
  }
  .duel-tabs #duel-tab-3 .players .list-full-bottom-center-bottom{
    font-size: 11px;
    color: #818E95;
    text-transform:uppercase;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .duel-tabs #duel-tab-3 .players .list-full-bottom-center-bottom img {
    margin-right: 2px;
  }
  .duel-tabs #duel-tab-3 .players .list-full-bottom-center-bottom img{
    width: 11px;
    height: 11px;
    position: relative;
  }

  .duel-tabs #duel-tab-3 .players .list-full-bottom-right-top{
    font-size: 14px;
    color: #445058;
    font-weight: 500;
    text-transform:uppercase;
  }
  .duel-tabs #duel-tab-3 .players .list-full-bottom-right-bottom{
    font-size: 11px;
    color: #818E95;
    text-transform:uppercase;
  }

  .duel-tabs #duel-tab-3 .players .list-full-content{
    height: 100px;
  }

  .duel-tabs #duel-tab-3 .players .list-full-top{
    height: 29px;
    flex-direction: row;
    padding-right: 10px;

  }
  .duel-tabs #duel-tab-3 .players .list-full-bottom{
    height: 33px;
    padding-right: 10px;
  }
  .duel-tabs #duel-tab-3 .players .list-full-top-left{
    font-size: 15px;
    color: #007AFF;
    white-space: nowrap;
    overflow: hidden;
    height: 1.3em;
    text-overflow: ellipsis;
  }
  .duel-tabs #duel-tab-3 .players .list-full-top-right{
    position: relative;
    top: 0;
    text-align: right;
    flex-shrink: 0;
  }

  .duel-tabs #duel-tab-3 .players .list-full-top-right{
    font-weight: bold;
    color: #445058;
  }

  /* Таб-4 */
  .duel-tabs .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 16px;
  }
  .duel-tabs .header .title {
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.41px;
    color: #445058;
  }
  .duel-tabs .header .subtitle {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: -0.08px;
    color: #818E95;
  }
  .duel-tabs .header .title + .subtitle {
    margin-top: 8px;
  }
  .duel-tabs .players-box {
    background: #FFFFFF;
    border: 1px solid #CFD6DB;
    display: flex;
    flex-direction: column;
    margin-top: 16px;
  }

  .duel-tabs .players-box .player-box {
    display: flex;
    flex-direction: column;
    width: 50%;
  }
  .duel-tabs .players-box .player-box + .player-box {
    border-left: 1px solid #CFD6DB;
    border-width: thin;
  }
  .duel-tabs .players-box.with-players-data .player-box .body {
    padding: 12px 0px;
  }
  .duel-tabs .players-box.with-players-data .player-box .body .description {
    justify-content: center;
  }
  .duel-tabs .players-box.with-players-data .player-box .body .description .pointers {
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 14px;
    letter-spacing: 0.35px;
    color: #818E95;
    display: flex;
    align-items: center;
  }
  .duel-tabs .players-box.with-players-data .player-box .body.data {
    flex-direction: column;
  }
  .duel-tabs .players-box.with-players-data .player-box .body .box {
    display: flex;
  }
  .duel-tabs .players-box.with-players-data .player-box.first-player .body .box {
    justify-content: flex-start;
  }
  .duel-tabs .players-box.with-players-data .player-box.second-player .body .box {
    justify-content: flex-end;
  }
  .duel-tabs .players-box.with-players-data .player-box .body .box + .box {
    margin-top: 6px;
  }
  .duel-tabs .players-box.with-players-data .player-box .body .description .pointers .pointer + .pointer {
    margin-left: 4px;
  }
  .duel-tabs .players-box.with-players-data .player-box .body .description .pointers .pgp {

  }
  .duel-tabs .players-box.with-players-data .player-box .body .description .pointers .value {
    color: #445058;
  }
  .duel-tabs .players-box.with-players-data .player-box .body .description {
    display: flex;
    flex-direction: column;
  }
  .duel-tabs .players-box.with-players-data .player-box .body.data .description.side {
    justify-content: flex-start;
    flex: 1;
    /* max-height: 58px; */
  }
  .duel-tabs .players-box.with-players-data .player-box .body.data .description.side .details {
    display: flex;
    flex-direction: column;
  }
  .duel-tabs .players-box.with-players-data .player-box .body.data .description.side .details {
    display: flex;
    flex-direction: column;
  }
  .duel-tabs .players-box.with-players-data .player-box .body.data .description.side .name + .match {
    margin-top: 2px;
  }
  .duel-tabs .players-box.with-players-data .player-box .body.data .description.side .match {
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 13px;
    letter-spacing: 0.35px;
    color: #445058;
    white-space: normal;
  }
  .duel-tabs .players-box.with-players-data .player-box .body.data .description.side .match .bold {
    font-weight: 600;
    color: #445058;
  }
  .duel-tabs .players-box.with-players-data .player-box .body.data .description.side .short-date {
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 13px;
    letter-spacing: 0.35px;
    text-transform: capitalize;
    color: #818E95;
  }
  .duel-tabs .players-box.with-players-data .player-box .body.data .description.side .match + .short-date {
    margin-top: 2px;
  }
  .duel-tabs .players-box.with-players-data .player-box .body.data .description.bottom .pointers {
    display: none;
    margin-top: 0px;
  }
  .duel-tabs .players-box.with-players-data .player-box .body.data .description.bottom .details .match {
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 14px;
    letter-spacing: 0.35px;
    color: #445058;
    white-space: normal;
  }
  .duel-tabs .players-box.with-players-data .player-box .body.data .description.bottom .details .short-date {
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 14px;
    letter-spacing: 0.35px;
    text-transform: capitalize;
    color: #818E95;
  }
  .duel-tabs .players-box.with-players-data .player-box .body.data .description.bottom .details .match .bold {
    font-weight: 600;
  }
  .duel-tabs .players-box.with-players-data .player-box .body.data .description.bottom .details .match + .short-date {
    margin-top: 4px;
  }
  .duel-tabs .players-box .player-box .body {
    background-color: #ffffff;
    height: auto;
    display: flex;
    justify-content: center;
    margin: 0px 12px;
  }
  .duel-tabs .players-box .player-box.first-player .body {
    margin: 0px 8px 0px 12px;
  }
  .duel-tabs .players-box .player-box.second-player .body {
    margin: 0px 12px 0px 8px;
  }
  .duel-tabs .players-box.with-players-data .player-box.first-player .body .description .pointers {
    justify-content: flex-start;
  }
  .duel-tabs .players-box.with-players-data .player-box.second-player .body .description .pointers {
    justify-content: flex-end;
  }
  .duel-tabs .players-box .player-box .body .player {
    width: 50px;
    height: 50px;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='5' ry='5' stroke='%23D0D6DAFF' stroke-width='2' stroke-dasharray='13%25%2c 13%25' stroke-dashoffset='13' stroke-linecap='round'/%3e%3c/svg%3e");
    border-radius: 5px;
    background-color: #F0F3F8;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .duel-tabs .players-box .player-box .body .player i {
    color: #CFD6DB;
  }
  .duel-tabs .players-box .player-box .body .player + .description {
    margin-left: 14px;
  }
  .duel-tabs .players-box .player-box .body .description + .player {
    margin-left: 14px;
  }
  .duel-tabs .players-box .player-box .body .description {
    display: flex;
    flex-direction: column;
    /* white-space: nowrap;
    overflow: hidden; */
  }
  .duel-tabs .players-box .player-box .body .description .pointers {
    margin-top: 4px;
    margin-bottom: 4px;
  }
  .duel-tabs .players-box .player-box .body .description .add-player-text {
    color: #007AFF;
    font-weight: 600;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: 0.35px;
  }
  .duel-tabs .players-box .player-box .body .description .pointers {
    height: 16px;
    width: 100%;
  }
  .duel-tabs .players-box .player-box .body .description .name {
    font-weight: 600;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: -0.35px;
    color: #007AFF;
    overflow: hidden;
    white-space: normal;
    height: 30px;
    display: flex;
    flex-direction: column;
  }
  .duel-tabs .players-box .player-box .body .description .localteam, .visitorteam {
    color: #000000;
  }
  .duel-tabs .players-box .player-box:nth-child(1) .body .description {
    text-align: left;
  }
  .duel-tabs .players-box .player-box:nth-child(2) .body .description {
    text-align: right;
  }
  .duel-tabs .players-box .player-box:nth-child(1) .body {
    border-top-left-radius: 9px;
  }
  .duel-tabs .players-box .player-box:nth-child(2) .body {
    border-top-right-radius: 9px;
  }
/*   .duel-tabs .players-box .player-box .body + .footer {
    border-top: 1px solid #CFD6DB;
    border-width: thin;
  } */
  .duel-tabs .players-box .player-box.footer {
    background-color: #FFFFFF;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .duel-tabs .players-box.with-players-data .player-box.footer {
    background-color: #FFFFFF;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #007AFF;
  }
/*   .duel-tabs .players-box .player-box:nth-child(1).footer {
    border-bottom-left-radius: 9px;
  }
  .duel-tabs .players-box .player-box:nth-child(2).footer {
    border-bottom-right-radius: 9px;
  } */
  .duel-tabs .players-box .player-box.footer span.disabled {
    font-size: 15px;
    line-height: 15px;
    letter-spacing: -0.24px;
    color: #CFD6DB;
  }
  .duel-tabs .players-box .player-box.first-player .body {
    justify-content: flex-start;
  }
  .duel-tabs .players-box .player-box.second-player .body {
    justify-content: flex-end;
  }
  .duel-tabs .players-box .player-box .body .player-with-data {
    width: 60px;
    height: 60px;
    border-radius: 5px;
    background-color: #F0F3F8;
    display: flex;
    justify-content: center;
  }
  .duel-tabs .players-box .player-box .body .player-with-data img {
    width: inherit;
    object-fit: cover;
  }
  .duel-tabs .players-box .player-box .body .player-with-data + .description {
    margin-left: 8px;
  }
  .duel-tabs .players-box .player-box .body .description + .player-with-data {
    margin-left: 8px;
  }

  .stepper-list {
    display: flex;
    align-items: center;
    padding: 0px;
  }
  .stepper-list li {
    list-style-type: none;
    background-color: #ffffff;
    border-radius: 50px;
    width: 18px;
    height: 18px;
    line-height: 14px;
    font-size: 11px;
    color: var(--f7-navbar-bg-color);
    letter-spacing: -0.24px;
    font-weight: normal;
    z-index: 900;
  }
  .stepper-list li span {
    width: 14px;
    height: 14px;
    background-color: #EFEFF4;
    display: block;
    margin: 2px;
    border-radius: 50px;
  }
  .stepper-list li.active {
    width: 22px;
    height: 22px;
    line-height: 18px;
    font-size: 14px;
  }
  .stepper-list li.active span {
    width: 18px;
    height: 18px;
  }

  .stepper-list li span i.icon-flag-svg {
    width: 12px;
    height: 12px;
  }

  .stepper-list li+li {
    margin-left: 8px;
  }
  .line {
    border-top: 2px solid #ffffff;
    width: 100%;
    position: absolute;
    top: 50%;
    z-index: 800;
  }
  /* Таб 1 */
  .duel-tabs #duel-tab-1 .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 16px;
  }
  .duel-tabs #duel-tab-1 .header .title {
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.41px;
    color: #445058;
  }
  .duel-tabs #duel-tab-1 .header .subtitle {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: -0.08px;
    color: #818E95;
  }
  .duel-tabs #duel-tab-1 .header .title + .subtitle {
    margin-top: 8px;
  }
  .duel-tabs #duel-tab-1 .players-box {
    background: #FFFFFF;
    border: 1px solid #CFD6DB;
    display: flex;
  }

  .duel-tabs #duel-tab-1 .players-box .player-box {
    display: flex;
    flex-direction: column;
    width: 50%;
  }
  .duel-tabs #duel-tab-1 .players-box .player-box + .player-box {
    border-left: 1px solid #CFD6DB;
    border-width: thin;
  }
  .duel-tabs #duel-tab-1 .players-box .player-box .body {
    background-color: #ffffff;
    height: 74px;
    display: flex;
    align-items: center;
  }
  .duel-tabs #duel-tab-1 .players-box .player-box.first-player .body {
    justify-content: flex-start;
  }
  .duel-tabs #duel-tab-1 .players-box .player-box.second-player .body {
    justify-content: flex-end;
  }
  .duel-tabs #duel-tab-1 .players-box .player-box .body .player {
    width: 50px;
    height: 50px;
/*     background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23EC3463' stroke-width='3' stroke-dasharray='20%25%2c 10%25' stroke-dashoffset='15' stroke-linecap='butt'/%3e%3c/svg%3e"); */
    border-radius: 5px;
    background-color: #F0F3F8;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .duel-tabs #duel-tab-1 .players-box .player-box .body .player i {
    color: #CFD6DB;
  }
  .duel-tabs #duel-tab-1 .players-box .player-box .body .player + .description {
    margin-left: 8px;
  }
  .duel-tabs #duel-tab-1 .players-box .player-box .body .description + .player {
    margin-left: 8px;
  }


  .duel-tabs #duel-tab-1 .players-box .player-box .body .description span {
    font-weight: 600;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: 0.35px;
    color: #007AFF;
  }
  .duel-tabs #duel-tab-1 .players-box .player-box:nth-child(1) .body .description {
    text-align: left;
  }
  .duel-tabs #duel-tab-1 .players-box .player-box:nth-child(2) .body .description {
    text-align: right;
  }


  .duel-tabs #duel-tab-1 .players-box .player-box:nth-child(1) .body {
    border-top-left-radius: 9px;
  }
  .duel-tabs #duel-tab-1 .players-box .player-box:nth-child(2) .body {
    border-top-right-radius: 9px;
  }

  .duel-tabs #duel-tab-1 .players-box .player-box .body + .footer {
    border-top: 1px solid #CFD6DB;
    border-width: thin;
  }

  .duel-tabs #duel-tab-1 .players-box .player-box .footer {
    background-color: #FFFFFF;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .duel-tabs #duel-tab-1 .players-box .player-box:nth-child(1) .footer {
    border-bottom-left-radius: 9px;
  }
  .duel-tabs #duel-tab-1 .players-box .player-box:nth-child(2) .footer {
    border-bottom-right-radius: 9px;
  }
  .duel-tabs #duel-tab-1 .players-box .player-box .footer span.disabled {
    font-size: 15px;
    line-height: 15px;
    letter-spacing: -0.24px;
    color: #CFD6DB;
  }
  /* duel-tab-2 */
  .duel-tabs #duel-tab-2 .calendar {
    height: 47px;
    display: flex;
    flex-direction: row;
  }
  .duel-tabs #duel-tab-2 .calendar .day {
    background-color: #E6E6E6;
    width: 100%;
    height: 45px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .duel-tabs #duel-tab-2 .calendar .day + .day {
/*     border-left: 1px solid #E6E6E6;
    border-width: thin; */
  }
  .duel-tabs #duel-tab-2 .calendar .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    height: 100%;
    width: 100%;
    margin: 1px;
  }
  .duel-tabs #duel-tab-2 .calendar .day span:nth-child(1) {
    font-weight: 300;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.07px;
    text-transform: uppercase;
    color: #15367A;
  }
  .duel-tabs #duel-tab-2 .calendar .day span:nth-child(2) {
    font-weight: 300;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: -0.24px;
    color: #15367A;
  }
  .duel-tabs #duel-tab-2 .calendar .day.today span {
    font-weight: bold;
  }
  .duel-tabs #duel-tab-2 .calendar .day.active::after {
    content: '';
    position: absolute;
    background-color: var(--f7-navbar-bg-color);
    display: block;
    z-index: 15;
    top: auto;
    right: auto;
    bottom: 0;
    left: 0;
    height: 3px;
    width: 100%;
    transform-origin: 50% 100%;
    transform: scaleY(calc(1 / 1));
    transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
  }
  .duel-tabs #duel-tab-2 .calendar .day.active .content {
    background-color: #F3F3F3;
  }
  .duel-tabs #duel-tab-2 > .matches {
    overflow: auto;
  }
  .duel-tabs #duel-tab-2 .matches .title {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: -0.08px;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.4);
    padding-top: 24px;
    margin: 0px 16px 8px;
  }
  .duel-tabs #duel-tab-2 .matches .list .accordion-item .item-content:after {
    content: '';
    position: absolute;
    background-color: var(--f7-list-border-color);
    display: block;
    z-index: 15;
    top: auto;
    right: auto;
    bottom: 0;
    left: 0;
    height: 1px;
    width: 100%;
    transform-origin: 50% 100%;
    transform: scaleY(calc(1 / 1));
    transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
  }
  .duel-tabs #duel-tab-2 .matches .accordion-list li:after {
    content: '';
    position: absolute;
    background-color: var(--f7-list-border-color);
    display: block;
    z-index: 15;
    top: auto;
    right: auto;
    bottom: 0;
    left: 0;
    height: 1px;
    width: 100%;
    transform-origin: 50% 100%;
    transform: scaleY(calc(1 / 1));
    transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
  }
  .duel-tabs #duel-tab-2 .matches .list .accordion-item .item-content .item-title {
    color: #000000;
  }

  .duel-tabs #duel-tab-2 .matches .accordion-list li .match-row {
    align-items: center;
    display: flex;
    height: 60px;
    margin-left: 16px;
  }
  .duel-tabs #duel-tab-2 .matches .accordion-list li .match-row .match-title {
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 17px;
    letter-spacing: -0.41px;
    color: #000000;
  }
  .duel-tabs #duel-tab-2 .matches .accordion-list li .match-row .match-title + .match-data {
    margin-top: 4px;
  }
  .duel-tabs #duel-tab-2 .matches .accordion-list li .match-row .match-data {
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 15px;
    letter-spacing: -0.24px;
    color: #8C8C8C;
  }
  .duel-tabs #duel-tab-2 .matches .accordion-list li .match-row .radio {
    margin-right: 16px;
  }
  .duel-tabs #duel-tab-2 .matches .accordion-list li .match-row .item-radio i {
    position: unset;
    top: unset;
    margin-top: unset;
    right: unset;
  }
  .duel-tabs #duel-tab-2 .matches .accordion-list li .match-row .match-block {
    display: flex;
    flex-direction: column;
  }

  /* Модалка с кнопкой "Дальше" */
  .sheet-save-btn {
    height: calc(79px + var(--f7-safe-area-bottom));
    box-shadow: 0px -1px 4px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }
  .sheet-save-btn .page-content {
    background-color: #ffffff;
  }
  .sheet-save-btn .page-content .block {
    margin-top: 15.5px;
    margin-bottom: calc(15.5px + var(--f7-safe-area-bottom));
  }
  .sheet-save-btn .page-content .block .button {
    height: 46px;
  }
    /* Модалка с кнопкой "Создать дуэль" */
  .sheet-сreate-duel-btn {
    height: calc(79px + var(--f7-safe-area-bottom));
    box-shadow: 0px -1px 4px rgba(0, 0, 0, 0.1);
  }
  .sheet-сreate-duel-btn .page-content {
    background-color: #ffffff;
  }
  .sheet-сreate-duel-btn .page-content .block {
    margin-top: 15.5px;
    margin-bottom: calc(15.5px + var(--f7-safe-area-bottom));
  }
  .sheet-сreate-duel-btn .page-content .block .button {
    height: 46px;
  }
  .sheet-сreate-duel-btn .page-content .block .button.disable {
    background: #CFD6DB;
    color: #818E95;
  }

  .duel-tabs .players-box .box-row {
    display: flex;
  }
  .duel-tabs .players-box .box-row + .box-row {
    border-top: 1px solid #CFD6DB;
    border-width: thin;
  }

  /* Сохраненная дуэль */
  .duel-tabs .box-row .saved-duel {
    display: flex;
    width: 100%;
  }
  .duel-tabs .box-row .saved-duel .player {
    flex: 1;
    height: 48px;
  }
  .duel-tabs .box-row .saved-duel .player .without-data {
    background-color: #FFFFFF;
    color:#007AFF;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .duel-tabs .box-row .saved-duel .player .me {
    display: flex;
    height: 48px;
    align-items: center;
  }
  .duel-tabs .box-row .saved-duel .player.first-player .me {
    justify-content: flex-start;
  }
  .duel-tabs .box-row .saved-duel .player.second-player .me {
    justify-content: flex-end;
  }
  .duel-tabs .box-row .saved-duel .player .me {
    margin: 0px 16px;
  }
  .duel-tabs .box-row .saved-duel .player .me img {
    width: 36px;
    height: 36px;
    object-fit: cover;
    border-radius: 50px;
  }
  .duel-tabs .box-row .saved-duel .player .me .info {
    display: flex;
    flex-direction: column;
  }
  .duel-tabs .box-row .saved-duel .player .me .info + img {
    margin-left: 8px;
  }
  .duel-tabs .box-row .saved-duel .player .me img + .info {
    margin-left: 8px;
  }
  .duel-tabs .box-row .saved-duel .player .me .info .name {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: -0.24px;
    color: #445058;
  }
  .duel-tabs .box-row .saved-duel .player .me .info .cost {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    color: #445058;
    display: flex;
    align-items: center;
  }
  .duel-tabs .box-row .saved-duel .player.first-player .me .info {
    align-items: flex-start;
  }
  .duel-tabs .box-row .saved-duel .player.second-player .me .info {
    align-items: flex-end;
  }
  .duel-tabs .box-row .saved-duel .player + .player {
    border-left: 1px solid #CFD6DB;
    border-width: thin;
  }

  @media (max-width: 375px) {
    .duel-tabs .players-box .player-box .body {
      margin: 0px 16px;
    }
    .duel-tabs .players-box.with-players-data .player-box .body.data .description.side .pointers {
      display: none;
    }
    .duel-tabs .players-box.with-players-data .player-box .body.data .description.bottom .pointers {
      display: flex;
    }
/*     .duel-tabs .players-box .player-box.first-player .body {
      margin: 0px 0px 0px 12px;
    }
    .duel-tabs .players-box .player-box.second-player .body {
      margin: 0px 8px 0px 12px;
    } */
  }
  @media (max-width: 320px) {
    .duel-tabs .players-box.with-players-data .player-box .body.data .description.side .match {
      font-size: 9px;
      line-height: 13px;
    }
    .duel-tabs .players-box.with-players-data .player-box .body.data .description.side .short-date {
      font-size: 9px;
      line-height: 13px;
    }
    .sheet-finish-duel {
      background: transparent;
      height: calc(302px + var(--f7-safe-area-bottom));
    }
    .duel-tabs .players-box .player-box .body {
      margin: 0px 8px;
    }
    .duel-tabs .players-box .player-box .body.data {
      margin: 0px 8px;
    }
    .duel-tabs #duel-tab-1 .players-box .player-box .body .description + .player {
      margin-left: 8px;
    }
    .duel-tabs #duel-tab-1 .players-box .player-box .body .player + .description {
      margin-left: 8px;
    }
    .duel-tabs .players-box .player-box .body .description + .player {
      margin-left: 8px;
    }

    .duel-tabs .players-box .player-box .body .player + .description {
      margin-left: 8px;
    }
    .duel-tabs .players-box.with-players-data .player-box .body.data .description.side .pointers {
      display: none;
    }
    .duel-tabs .players-box.with-players-data .player-box .body.data .description.bottom .pointers {
      display: flex;
    }
/*     .duel-tabs .players-box .player-box.first-player .body {
      margin: 0px 0px 0px 8px;
    }
    .duel-tabs .players-box .player-box.second-player .body {
      margin: 0px 8px 0px 0px;
    } */
  }
`,
  styleScoped: false
};
    